<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div v-if="isLoading" class="py-4 text-muted">Carregando fluxo…</div>

                    <div v-else-if="hasWorkflow">
                        <div v-if="!isWorkflowAtivo" class="workflow-readonly-banner">
                            <div class="d-flex align-items-start gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 4.005a.55.55 0 0 1-1.1 0z" />
                                </svg>
                                <div>
                                    <div class="fw-semibold">Fluxo inativo</div>
                                    <div class="small">
                                        Você pode visualizar os modelos e tooltips, porém <strong>não é possível alterar configurações</strong> neste fluxo.
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="workflow-board mt-3">
                            <div class="workflow-board__header d-flex align-items-center justify-content-between">
                                <h5 class="mb-0">Modelos do Fluxo</h5>
                                <button type="button"
                                        class="btn btn-outline-secondary d-inline-flex align-items-center gap-2"
                                        title="Controle Geral do Fluxo"
                                        :disabled="!isWorkflowAtivo"
                                        @click="handleOpenModalGeral">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-gear-fill" viewBox="0 0 16 16">
                                        <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z" />
                                    </svg>
                                    Controle geral
                                </button>
                            </div>

                            <div class="workflow-board__body">
                                <div class="wf-wrapper">
                                    <div class="wf-toolbar d-flex align-items-center justify-content-between flex-wrap gap-2">
                                        <div class="d-flex align-items-center gap-2 text-muted small">
                                            <span>{{ graphNodes.length }} nós • {{ graphEdges.length }} conexões</span>
                                            <span v-if="organizandoOrdem" class="wf-order-hint">
                                                Arraste os cards para reorganizar
                                                <strong v-if="ordemAlterada">• alterações não salvas</strong>
                                            </span>
                                        </div>
                                        <div class="d-flex align-items-center gap-2 flex-wrap">
                                            <div class="wf-toolbar-name">
                                                <label for="nomeWorkflowDetalhe" class="visually-hidden">Nome do fluxo</label>
                                                <input id="nomeWorkflowDetalhe"
                                                       v-model.trim="nomeWorkflowEditado"
                                                       type="text"
                                                       maxlength="500"
                                                       class="form-control form-control-sm"
                                                       placeholder="Nome do fluxo"
                                                       :disabled="!isWorkflowAtivo || salvandoNomeWorkflow"
                                                       @keyup.enter="salvarNomeWorkflow" />
                                                <button type="button"
                                                        class="btn btn-sm btn-outline-secondary"
                                                        :disabled="!podeSalvarNomeWorkflow"
                                                        @click="salvarNomeWorkflow">
                                                    <span v-if="salvandoNomeWorkflow"
                                                          class="spinner-border spinner-border-sm me-1"
                                                          role="status"
                                                          aria-hidden="true"></span>
                                                    Salvar nome
                                                </button>
                                            </div>
                                            <template v-if="organizandoOrdem">
                                                <button class="btn btn-sm btn-outline-secondary"
                                                        :disabled="salvandoOrdem"
                                                        @click="cancelarOrganizacaoOrdem">
                                                    Cancelar
                                                </button>
                                                <button class="btn btn-sm btn-primary d-inline-flex align-items-center gap-2"
                                                        :disabled="salvandoOrdem || !ordemAlterada"
                                                        @click="salvarOrdem">
                                                    <span v-if="salvandoOrdem" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                    Salvar ordem
                                                </button>
                                            </template>
                                            <button v-else
                                                    class="btn btn-sm btn-outline-primary"
                                                    :disabled="!isWorkflowAtivo || loadingDeps || graphNodes.length === 0"
                                                    @click="iniciarOrganizacaoOrdem">
                                                Organizar ordem
                                            </button>
                                            <button v-if="!organizandoOrdem"
                                                    class="btn btn-sm btn-primary d-inline-flex align-items-center gap-1"
                                                    :disabled="!isWorkflowAtivo"
                                                    @click="abrirModalNovoArtefato">
                                                <svg xmlns="http://www.w3.org/2000/svg"
                                                     width="16"
                                                     height="16"
                                                     viewBox="0 0 24 24"
                                                     fill="currentColor"
                                                     aria-hidden="true">
                                                    <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
                                                </svg>
                                                Adicionar artefato
                                            </button>
                                            <div v-if="graphNodes.length > 0" class="btn-group" role="group" aria-label="Zoom">
                                                <button class="btn btn-sm btn-outline-secondary" @click="zoomOut" title="Diminuir zoom">-</button>
                                                <button class="btn btn-sm btn-outline-secondary" @click="resetZoom" title="Redefinir zoom">100%</button>
                                                <button class="btn btn-sm btn-outline-secondary" @click="zoomIn" title="Aumentar zoom">+</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="graphNodes.length === 0" class="models-empty">
                                        Nenhum modelo encontrado.
                                    </div>
                                    <template v-else>
                                    <div class="wf-readonly-overlay" v-if="!isWorkflowAtivo">
                                        <div class="wf-readonly-overlay__pill">
                                            Fluxo inativo • Somente leitura
                                        </div>
                                    </div>
                                    <div class="wf-canvas" :class="{ 'is-panning': panning.active }" :style="{ width: '100%', height: canvasHeightPx + 'px' }" ref="wfCanvas" @mousedown="onCanvasMouseDown">
                                        <div class="wf-inner" :style="innerStyle">
                                            <svg class="wf-edges" :width="canvasWidthPx" :height="canvasHeightPx">
                                                <defs>
                                                    <marker id="wfArrow"
                                                            viewBox="0 0 10 10"
                                                            refX="9" refY="5"
                                                            markerWidth="7" markerHeight="7"
                                                            markerUnits="userSpaceOnUse"
                                                            orient="auto">
                                                        <path d="M 0 0 L 10 5 L 0 10 z" />
                                                    </marker>
                                                    <marker id="wfArrowActive"
                                                            viewBox="0 0 10 10"
                                                            refX="9" refY="5"
                                                            markerWidth="8" markerHeight="8"
                                                            markerUnits="userSpaceOnUse"
                                                            orient="auto">
                                                        <path d="M 0 0 L 10 5 L 0 10 z" />
                                                    </marker>
                                                </defs>

                                                <g v-for="e in routedEdges"
                                                   :key="e.key"
                                                   class="wf-edge-group"
                                                   :class="edgeClasses(e)"
                                                   @mouseenter="hoveredEdgeKey = e.key"
                                                   @mouseleave="hoveredEdgeKey = null">
                                                    <path class="wf-edge-halo" :d="e.path" />
                                                    <path class="wf-edge-line"
                                                          :d="e.path"
                                                          :marker-end="edgeMarker(e)" />
                                                    <path class="wf-edge-hit" :d="e.path">
                                                        <title>{{ e.label }}</title>
                                                    </path>
                                                </g>
                                            </svg>
                                            <div v-for="n in graphNodes" :key="'n-' + n.id" class="wf-node"
                                                 :class="{ 'wf-node--readonly': !isWorkflowAtivo, 'wf-node--inativo': !isArtefatoAtivo(n.cfg), 'wf-node--ordering': organizandoOrdem, 'wf-node--dragging': dragging.id === n.id }" :style="nodeStyle(n)" :data-id="n.id"
                                                 role="button" :tabindex="isWorkflowAtivo ? 0 : -1" :aria-disabled="!isWorkflowAtivo"
                                                 @mousedown="isWorkflowAtivo && organizandoOrdem && onNodeMouseDown($event, n.id)"
                                                 @click="isWorkflowAtivo && !organizandoOrdem && onNodeClick(n.id, $event)"
                                                 @keyup.enter.space="isWorkflowAtivo && !organizandoOrdem && openModeloById(n.id)"
                                                 @mouseenter="hoveredNodeId = n.id"
                                                 @mouseleave="hoveredNodeId = null">
                                                <span class="wf-node-order" :title="`Ordem ${n.ordem}`">{{ n.ordem }}</span>
                                                <div class="wf-node-body">
                                                    <div class="wf-node-title" :title="n.label">{{ n.label }}</div>
                                                    <div class="wf-node-meta">
                                                        <span class="chip custom-tooltip"
                                                              :class="[n.cfg?.flPrazo ? 'chip-on' : 'chip-off', getTooltipPrazo(n.cfg) ? `tooltip-${getTooltipPrazo(n.cfg).type}` : '']">
                                                            <template v-if="n.cfg?.flPrazo">
                                                                {{ n.cfg?.nrDiasPrazo }} dia(s) ({{ tipoDiasLabel(n.cfg?.tpDiasPrazo) }})
                                                            </template>
                                                            <template v-else>
                                                                Sem prazo
                                                            </template>
                                                            <!-- Tooltip embutido -->
                                                            <div class="tooltip-content" v-if="getTooltipPrazo(n.cfg)">
                                                                <div>{{ getTooltipPrazo(n.cfg).text }}</div>
                                                                <div style="font-weight: 600; margin-top: 4px;">
                                                                    {{ getTooltipPrazo(n.cfg).subtitle }}
                                                                </div>
                                                            </div>
                                                        </span>
                                                        <span class="chip custom-tooltip"
                                                              :class="[n.cfg?.flRevisao ? 'chip-on' : 'chip-off', getTooltipRevisao(n.cfg) ? `tooltip-${getTooltipRevisao(n.cfg).type}` : '']">
                                                            Revisão
                                                            <div class="tooltip-content" v-if="getTooltipRevisao(n.cfg)">
                                                                <div>{{ getTooltipRevisao(n.cfg).text }}</div>
                                                                <div style="font-weight: 600; margin-top: 4px;">{{ getTooltipRevisao(n.cfg).subtitle }}</div>
                                                            </div>
                                                        </span>
                                                        <span class="chip custom-tooltip"
                                                              :class="[n.cfg?.flAprovacao ? 'chip-on' : 'chip-off', getTooltipAprovacao(n.cfg) ? `tooltip-${getTooltipAprovacao(n.cfg).type}` : '']">
                                                            Aprovação
                                                            <div class="tooltip-content" v-if="getTooltipAprovacao(n.cfg)">
                                                                <div>{{ getTooltipAprovacao(n.cfg).text }}</div>
                                                                <div style="font-weight: 600; margin-top: 4px;">{{ getTooltipAprovacao(n.cfg).subtitle }}</div>
                                                            </div>
                                                        </span>
                                                        <span class="chip custom-tooltip"
                                                              :class="[n.cfg?.flAssinatura ? 'chip-on' : 'chip-off', getTooltipAssinatura(n.cfg) ? `tooltip-${getTooltipAssinatura(n.cfg).type}` : '']">
                                                            Assinatura
                                                        </span>
                                                    </div>
                                                    <div class="wf-node-deps" v-if="!loadingDeps">
                                                        <span class="chip custom-tooltip"
                                                              :class="[
                                                              depModeloNomesByModeloId(n.id).length>
                                                            0 ? 'chip-on' : 'chip-off',
                                                            getTooltipDependencias(n.id) ? `tooltip-${getTooltipDependencias(n.id).type}` : ''
                                                            ]">
                                                            <template v-if="depModeloNomesByModeloId(n.id).length > 0">
                                                                Dependências
                                                            </template>
                                                            <template v-else>
                                                                Independente
                                                            </template>
                                                            <div class="tooltip-content" v-if="getTooltipDependencias(n.id)">
                                                                <div class="tooltip-title">{{ getTooltipDependencias(n.id).text }}</div>
                                                                <ul class="tooltip-list">
                                                                    <li v-for="(dep, index) in getTooltipDependencias(n.id).list" :key="index">
                                                                        {{ dep }}
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </span>
                                                    </div>
                                                </div>
                                                <span class="wf-node-status custom-tooltip"
                                                      :class="isArtefatoAtivo(n.cfg) ? 'wf-node-status--ativo tooltip-success' : 'wf-node-status--inativo tooltip-danger'">
                                                    <svg v-if="isArtefatoAtivo(n.cfg)" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                                                        <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                                    </svg>
                                                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="currentColor">
                                                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                                    </svg>
                                                    <div class="tooltip-content">
                                                        <div>{{ isArtefatoAtivo(n.cfg) ? 'Artefato ativo' : 'Artefato inativo' }}</div>
                                                        <div style="font-weight: 600; margin-top: 4px;">
                                                            {{ isArtefatoAtivo(n.cfg) ? 'Exigido nos processos deste fluxo' : 'Não é exigido em novos processos' }}
                                                        </div>
                                                    </div>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <ModalWorkflowConfiguracao ref="modalConfig"
                                   :id-processo-workflow-artefato="selectedConfigId"
                                   :modelos-artefatos="modelosArtefatosParaConfiguracao"
                                   :blocked-model-ids="blockedModelIdsForSelected"
                                   @saved="refreshConfigs"
                                   @renamed="onArtefatoRenomeado" />
        <ModalWorkflowNovoArtefato ref="modalNovoArtefato"
                                   :id-processo-workflow="workflow?.idProcessoWorkflow || null"
                                   :artefatos="modelosArtefatosParaConfiguracao"
                                   @saved="onNovoArtefatoSalvo" />


        <!-- MODAL PRIMEIROS PASSOS (bloqueante) -->
        <div class="modal fade" id="ModalFirstStepsWorkflow" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Configurando Fluxo pela primeira vez
                            <span v-if="loadingPostAutomatico" class="ms-2 align-middle">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </span>
                        </h5>
                        <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                                :disabled="loadingPostAutomatico" data-bs-dismiss="modal">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                            </svg>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="mb-3">
                            Não encontramos configurações para este fluxo. Vamos criar uma configuração inicial para
                            <strong>cada modelo de artefato</strong>.
                        </p>

                        <ul class="mb-3">
                            <li>Criaremos uma configuração por modelo, com todas as regras <strong>desativadas por padrão</strong>.</li>
                            <li>Você pode ajustar tudo de uma vez pelo <strong>Controle geral</strong>; as alterações serão aplicadas a todos os modelos.</li>
                            <li>Se preferir, também dá para configurar <strong>modelo a modelo</strong>. Clique no cartão do artefato para abrir as opções.</li>
                        </ul>

                        <div class="rounded bg-light p-3 border">
                            <div class="d-flex align-items-center justify-content-between mb-2">
                                <span>Progresso:</span>
                                <span><strong>{{ bootstrapProgress.done }}</strong> / {{ bootstrapProgress.total }}</span>
                            </div>
                            <div class="progress" style="height: 10px;">
                                <div class="progress-bar"
                                     role="progressbar"
                                     :style="{ width: bootstrapBarWidth }"
                                     :aria-valuenow="bootstrapProgress.done"
                                     aria-valuemin="0"
                                     :aria-valuemax="bootstrapProgress.total">
                                </div>
                            </div>
                            <div v-if="bootstrapProgress.errorCount > 0" class="mt-2 text-danger small">
                                Ocorreram {{ bootstrapProgress.errorCount }} falha(s). Verifique sua conexão ou a rota de salvamento.
                            </div>
                        </div>

                        <p class="mt-3 mb-0 text-muted small">
                            Esta etapa é automática e rápida. Mantemos a tela bloqueada até concluir para garantir consistência.
                        </p>
                    </div>

                </div>
            </div>
        </div>
        <Modais></Modais>
        <!-- MODAL CONTROLE GERAL -->
        <div class="modal fade modern-modal" id="ModalWorkflowGeral" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl modal-modern">
                <div class="modal-content modal-modern-content border-0">
                    <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                            :disabled="savingGeral"
                            data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                             fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10M10,22C9.75,22 9.54,21.82 9.5,21.58L9.13,18.93C8.5,18.68 7.96,18.34 7.44,17.94L4.95,18.95C4.73,19.03 4.46,18.95 4.34,18.73L2.34,15.27C2.21,15.05 2.27,14.78 2.46,14.63L4.57,12.97L4.5,12L4.57,11L2.46,9.37C2.27,9.22 2.21,8.95 2.34,8.73L4.34,5.27C4.46,5.05 4.73,4.96 4.95,5.05L7.44,6.05C7.96,5.66 8.5,5.32 9.13,5.07L9.5,2.42C9.54,2.18 9.75,2 10,2H14C14.25,2 14.46,2.18 14.5,2.42L14.87,5.07C15.5,5.32 16.04,5.66 16.56,6.05L19.05,5.05C19.27,4.96 19.54,5.05 19.66,5.27L21.66,8.73C21.79,8.95 21.73,9.22 21.54,9.37L19.43,11L19.5,12L19.43,13L21.54,14.63C21.73,14.78 21.79,15.05 21.66,15.27L19.66,18.73C19.54,18.95 19.27,19.04 19.05,18.95L16.56,17.95C16.04,18.34 15.5,18.68 14.87,18.93L14.5,21.58C14.46,21.82 14.25,22 14,22H10M11.25,4L10.88,6.61C9.68,6.86 8.62,7.5 7.85,8.39L5.44,7.35L4.69,8.65L6.8,10.2C6.4,11.37 6.4,12.64 6.8,13.8L4.68,15.36L5.43,16.66L7.86,15.62C8.63,16.5 9.68,17.14 10.87,17.38L11.24,20H12.76L13.13,17.39C14.32,17.14 15.37,16.5 16.14,15.62L18.57,16.66L19.32,15.36L17.2,13.81C17.6,12.64 17.6,11.37 17.2,10.2L19.31,8.65L18.56,7.35L16.15,8.39C15.38,7.5 14.32,6.86 13.12,6.62L12.75,4H11.25Z" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Controle Geral do Fluxo</h2>
                            <p>Aplique regras de prazo, revisão, aprovação e assinatura em todos os artefatos de uma só vez.</p>
                        </div>
                        <div class="header-status">
                            <span v-if="savingGeral" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span class="badge badge-artefato">Aplicação a todos os artefatos</span>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div class="section-stack">
                            <div class="section-card">
                                <div class="section-header">
                                    <div class="section-header__info">
                                        <div class="section-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                                                <path d="M15,13H16.5V15.82L18.94,17.23L18.19,18.53L15,16.69V13M19,8H5V19H9.67C9.24,18.09 9,17.07 9,16A7,7 0 0,1 16,9C17.07,9 18.09,9.24 19,9.67V8M5,21C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H6V1H8V3H16V1H18V3H19A2,2 0 0,1 21,5V11.1C22.24,12.36 23,14.09 23,16A7,7 0 0,1 16,23C14.09,23 12.36,22.24 11.1,21H5M16,11.15A4.85,4.85 0 0,0 11.15,16C11.15,18.68 13.32,20.85 16,20.85A4.85,4.85 0 0,0 20.85,16C20.85,13.32 18.68,11.15 16,11.15Z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <h3>Prazos</h3>
                                            <p>Defina a duração padrão e o tipo de contagem que todos os artefatos seguirão.</p>
                                        </div>
                                    </div>
                                    <div class="section-header__actions">
                                        <div class="form-check form-switch modern-switch m-0">
                                            <input class="form-check-input" type="checkbox" id="swGeralPrazo" v-model="geralForm.flPrazo">
                                            <label class="form-check-label fw-medium" for="swGeralPrazo">Possui prazo</label>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="geralForm.flPrazo === true" class="section-content">
                                    <div class="form-grid">
                                        <div class="form-group">
                                            <label class="form-label">Número de dias</label>
                                            <input type="number"
                                                   min="0"
                                                   class="form-control"
                                                   v-model.number="geralForm.nrDiasPrazo"
                                                   placeholder="Ex.: 10">
                                        </div>
                                        <div class="form-group">
                                            <label class="form-label">Tipo de dias</label>
                                            <select class="form-select" v-model="geralForm.tpDiasPrazo">
                                                <option value="CRD">Corridos</option>
                                                <option value="UTS">Úteis</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="section-note">
                                        O prazo será sempre contado a partir do <strong>início do processo</strong> para todos os artefatos.
                                    </div>
                                </div>
                            </div>

                            <div class="section-grid">
                                <div class="section-card section-card--compact">
                                    <div class="section-header">
                                        <div class="section-header__info">
                                            <div class="section-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                                    <path d="M20 17H22V15H20V17M20 7V13H22V7M6 16H11V18H6M6 12H14V14H6M4 2C2.89 2 2 2.89 2 4V20C2 21.11 2.89 22 4 22H16C17.11 22 18 21.11 18 20V8L12 2M4 4H11V9H16V20H4Z" />
                                                </svg>
                                            </div>
                                            <div>
                                                <h3>Revisão</h3>
                                                <p>Determine se todos os artefatos exigirão revisão.</p>
                                            </div>
                                        </div>
                                        <div class="section-header__actions">
                                            <div class="form-check form-switch modern-switch m-0">
                                                <input class="form-check-input" type="checkbox" id="swGeralRevisao" v-model="geralForm.flRevisao">
                                                <label class="form-check-label fw-medium" for="swGeralRevisao">Necessário revisão</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="geralForm.flRevisao === true" class="section-content">
                                        <p class="runtime-envolvidos-note mb-0">
                                            Os revisores serão escolhidos no envio de cada artefato, pelo responsável na tela de continuidade.
                                        </p>
                                    </div>

                                </div>

                                <div class="section-card section-card--compact">
                                    <div class="section-header">
                                        <div class="section-header__info">
                                            <div class="section-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                                    <path d="M23.5 17L18.5 22L15 18.5L16.5 17L18.5 19L22 15.5L23.5 17M6 2C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H13.81C13.45 21.38 13.2 20.7 13.08 20H6V4H13V9H18V13.08C18.33 13.03 18.67 13 19 13C19.34 13 19.67 13.03 20 13.08V8L14 2M8 12V14H16V12M8 16V18H13V16Z" />
                                                </svg>
                                            </div>
                                            <div>
                                                <h3>Aprovação</h3>
                                                <p>Determine se todos os artefatos exigirão aprovação.</p>
                                            </div>
                                        </div>
                                        <div class="section-header__actions">
                                            <div class="form-check form-switch modern-switch m-0">
                                                <input class="form-check-input" type="checkbox" id="swGeralAprovacao" v-model="geralForm.flAprovacao">
                                                <label class="form-check-label fw-medium" for="swGeralAprovacao">Necessário aprovação</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="geralForm.flAprovacao === true" class="section-content">
                                        <p class="runtime-envolvidos-note mb-0">
                                            Os aprovadores serão escolhidos no envio de cada artefato, pelo responsável na tela de continuidade.
                                        </p>
                                    </div>
                                </div>

                                <div class="section-card section-card--compact">
                                    <div class="section-header">
                                        <div class="section-header__info">
                                            <div class="section-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                                    <path d="M19.7 12.9L14 18.6H11.7V16.3L17.4 10.6L19.7 12.9M23.1 12.1C23.1 12.4 22.8 12.7 22.5 13L20 15.5L19.1 14.6L21.7 12L21.1 11.4L20.4 12.1L18.1 9.8L20.3 7.7C20.5 7.5 20.9 7.5 21.2 7.7L22.6 9.1C22.8 9.3 22.8 9.7 22.6 10C22.4 10.2 22.2 10.4 22.2 10.6C22.2 10.8 22.4 11 22.6 11.2C22.9 11.5 23.2 11.8 23.1 12.1M3 20V4H10V9H15V10.5L17 8.5V8L11 2H3C1.9 2 1 2.9 1 4V20C1 21.1 1.9 22 3 22H15C16.1 22 17 21.1 17 20H3M11 17.1C10.8 17.1 10.6 17.2 10.5 17.2L10 15H8.5L6.4 16.7L7 14H5.5L4.5 19H6L8.9 16.4L9.5 18.7H10.5L11 18.6V17.1Z" />
                                                </svg>
                                            </div>
                                            <div>
                                                <h3>Assinatura</h3>
                                                <p>Opcionalmente exija assinatura digital em todos os artefatos gerados.</p>
                                            </div>
                                        </div>
                                        <div class="section-header__actions">
                                            <div class="form-check form-switch modern-switch m-0">
                                                <input class="form-check-input" type="checkbox" id="swGeralAssinatura" v-model="geralForm.flAssinatura">
                                                <label class="form-check-label fw-medium" for="swGeralAssinatura">Necessário assinatura</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="section-note section-note--muted">
                            Ao salvar, aplicaremos essas definições a <strong>todas</strong> as configurações de artefato deste fluxo.
                        </div>
                    </div>

                    <div class="modal-modern-footer">
                        <button type="button"
                                class="btn btn-modern-primary w-100"
                                :disabled="savingGeral"
                                @click="saveModalGeral">
                            <span v-if="savingGeral" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Salvar para todos
                        </button>
                    </div>
                </div>
            </div>
        </div>   <!-- /MODAL CONTROLE GERAL -->
    </div>
</template>


<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import ModalWorkflowConfiguracao from '@/components/ProcessoWorkflow/ModalWorkflowConfiguracao.vue'
    import ModalWorkflowNovoArtefato from '@/components/ProcessoWorkflow/ModalWorkflowNovoArtefato.vue'
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    export default {
        name: 'DetalhesWorkflows',
        components: { Header, ModalWorkflowConfiguracao, ModalWorkflowNovoArtefato, Modais },
        data: function () {
            return {
                workflow: {},
                workflowConfig: [],
                workflowLegislacao: {},
                workflowTipoProcesso: {},
                modelosArtefatosWorkflow: [],
                idTipoProcesso: null,
                idLegislacao: null,
                nomeWorkflowEditado: '',
                salvandoNomeWorkflow: false,
                selectedConfigId: null,
                isLoading: false,
                hasWorkflow: false,
                isBootstrapping: false,
                bootstrapProgress: { total: 0, done: 0, errorCount: 0 },
                loadingPostAutomatico: false,
                firstStepsModal: null,
                geralForm: {
                    flPrazo: false,
                    flRevisao: false,
                    flAssinatura: false,
                    flAprovacao: false,
                    nrDiasPrazo: null,
                    tpDiasPrazo: 'CRD',
                    tpInicioPrazo: 'INICIO',
                },

                savingGeral: false,
                modalGeral: null,
                geralProgress: { total: 0, done: 0, errorCount: 0 },
                dependenciasByCfgId: {},
                loadingDeps: false,
                organizandoOrdem: false,
                salvandoOrdem: false,
                ordemAlterada: false,
                ordemOriginal: [],
                ordemRascunho: [],
                // Grafo/layout
                zoom: 1,
                nodeWidth: 360,
                nodeMinHeight: 120,
                otherRowsGap: 64,
                canvasPadding: 40,
                edgeCornerRadius: 10,
                // Roteamento das conexões
                medidasNodes: {},
                vaoMinimo: 76,
                faixaMargem: 26,
                faixaEspacamento: 18,
                faixaSeparacao: 28,
                viewport: { w: 0, h: 0 },
                minCanvasHeight: 480,
                hoveredNodeId: null,
                hoveredEdgeKey: null,
                // Drag
                manualPositions: {},
                dragging: { id: null, offsetX: 0, offsetY: 0, startX: 0, startY: 0, moved: false },
                suppressClickOnce: false,
                panX: 0,
                panY: 0,
                panning: { active: false, startX: 0, startY: 0, startPanX: 0, startPanY: 0 },
            }
        },

        computed: {
            innerStyle() {
                return {
                    transform: `translate(${this.panX}px, ${this.panY}px) scale(${this.zoom})`,
                    transformOrigin: '0 0',
                };
            },

            isWorkflowAtivo() {
                return this.workflow?.flAtivo === true;
            },
            podeSalvarNomeWorkflow() {
                const nome = (this.nomeWorkflowEditado || '').trim();
                return this.isWorkflowAtivo &&
                    !this.salvandoNomeWorkflow &&
                    nome.length > 0 &&
                    nome.length <= 500 &&
                    nome !== (this.workflow?.nmProcessoWorkflow || '').trim();
            },
            bootstrapBarWidth() {
                if (this.bootstrapProgress.total === 0) return '0%';
                let pct = Math.round((this.bootstrapProgress.done / this.bootstrapProgress.total) * 100);
                if (pct < 0) pct = 0;
                if (pct > 100) pct = 100;
                return pct + '%';
            },
            cfgById() {
                const map = {};
                (this.workflowConfig || []).forEach(c => {
                    if (c && c.idProcessoWorkflowArtefato) {
                        map[c.idProcessoWorkflowArtefato] = c;
                    }
                });
                return map;
            },
            cfgByModeloId() {
                const map = {};
                (this.workflowConfig || []).forEach(c => {
                    if (c && c.idProcessoModeloArtefato) {
                        map[c.idProcessoModeloArtefato] = c;
                    }
                });
                return map;
            },
            modelosById() {
                const map = {};
                (this.modelosArtefatosWorkflow || []).forEach(m => {
                    if (m?.idProcessoModeloArtefato) map[m.idProcessoModeloArtefato] = m;
                });
                return map;
            },
            modelosArtefatosParaConfiguracao() {
                return (this.modelosArtefatosWorkflow || []).map(modelo => {
                    const configuracao = this.cfgByModeloId[modelo.idProcessoModeloArtefato];
                    return {
                        ...modelo,
                        idProcessoWorkflowArtefato: configuracao?.idProcessoWorkflowArtefato ?? null,
                        nrOrdem: configuracao?.nrOrdem ?? null,
                        flAtivo: configuracao?.flAtivo !== false
                    };
                });
            },
            depthById() {
                const incoming = {};
                const ids = (this.modelosArtefatosWorkflow || []).map(m => m.idProcessoModeloArtefato);
                ids.forEach(id => incoming[id] = new Set());
                this.graphEdges.forEach(e => { if (incoming[e.to]) incoming[e.to].add(e.from); });
                const memo = {};
                const dfs = (id) => {
                    if (memo[id] != null) return memo[id];
                    const preds = incoming[id] || new Set();
                    if (preds.size === 0) { memo[id] = 0; return 0; }
                    let d = 0; preds.forEach(p => { d = Math.max(d, dfs(p) + 1); });
                    memo[id] = d; return d;
                };
                const map = {};
                ids.forEach(id => { map[id] = dfs(id); });
                return map;
            },
            levelsCount() {
                const vals = Object.values(this.depthById);
                if (vals.length === 0) return 1;
                return Math.max(...vals) + 1;
            },
            containerWidthPx() {
                const el = this.$refs.wfCanvas?.parentElement;
                const w = el?.clientWidth || this.viewport.w || 0;
                return Math.max(600, w);
            },
            nodeWidthPx() {
                const available = Math.max(280, this.containerWidthPx - this.canvasPadding * 2);
                return Math.min(this.nodeWidth, available);
            },
            orderColumns() {
                const available = Math.max(this.nodeWidthPx, this.containerWidthPx - this.canvasPadding * 2);
                return Math.max(1, Math.floor((available + this.otherRowsGap) / (this.nodeWidthPx + this.otherRowsGap)));
            },
            nodeHeightsMap() {
                return this.medidasNodes;
            },
            canvasWidthPx() {
                const maxEdgeX = this.routedEdges.length
                    ? Math.max(...this.routedEdges.map(edge => edge.maxX))
                    : 0;
                return Math.max(this.containerWidthPx, maxEdgeX + this.canvasPadding);
            },
            canvasHeightPx() {
                const pad = this.canvasPadding;
                const ys = Object.keys(this.positionsById)
                    .map(id => this.positionsById[id].y + (this.nodeHeightsMap[id] || this.nodeMinHeight));
                const maxNodeY = ys.length ? Math.max(...ys) : 0;
                const maxEdgeY = this.routedEdges.length
                    ? Math.max(...this.routedEdges.map(edge => edge.maxY))
                    : 0;
                const needed = Math.max(maxNodeY, maxEdgeY) + pad;
                return Math.max(needed, this.availableCanvasHeightPx);
            },
            graphNodes() {
                const modelos = this.modelosById;
                const idsOrdenados = this.idsModelosOrdenados;
                return idsOrdenados.map((id, index) => {
                    const m = modelos[id];
                    return {
                        id: m.idProcessoModeloArtefato,
                        label: m.nmModelo,
                        cfg: this.cfgByModeloId[m.idProcessoModeloArtefato] || null,
                        ordem: index + 1
                    };
                });
            },
            idsModelosOrdenados() {
                const modelos = [...(this.modelosArtefatosWorkflow || [])];
                modelos.sort((a, b) => {
                    const cfgA = this.cfgByModeloId[a.idProcessoModeloArtefato];
                    const cfgB = this.cfgByModeloId[b.idProcessoModeloArtefato];
                    const inativoA = cfgA?.flAtivo === false ? 1 : 0;
                    const inativoB = cfgB?.flAtivo === false ? 1 : 0;
                    if (inativoA !== inativoB) return inativoA - inativoB;

                    const ordemA = cfgA?.nrOrdem ?? a.nrOrdem ?? Number.MAX_SAFE_INTEGER;
                    const ordemB = cfgB?.nrOrdem ?? b.nrOrdem ?? Number.MAX_SAFE_INTEGER;
                    if (ordemA !== ordemB) return ordemA - ordemB;
                    return a.idProcessoModeloArtefato - b.idProcessoModeloArtefato;
                });

                const fallback = modelos.map(x => x.idProcessoModeloArtefato);
                if (!this.organizandoOrdem || !this.ordemRascunho.length) return fallback;

                const existentes = new Set(fallback);
                return [
                    ...this.ordemRascunho.filter(id => existentes.has(id)),
                    ...fallback.filter(id => !this.ordemRascunho.includes(id))
                ];
            },
            // Fonte única das dependências, indexada pelo modelo dependente. As setas do
            // fluxo e o selo do card leem daqui para que nunca discordem entre si.
            dependenciasPorModeloId() {
                const mapa = {};
                (this.workflowConfig || []).forEach(cfg => {
                    const idConfiguracao = cfg?.idProcessoWorkflowArtefato;
                    const idModelo = cfg?.idProcessoModeloArtefato;
                    if (!cfg?.flDependencia || !idConfiguracao || !idModelo) return;
                    if (!this.modelosById[idModelo]) return;

                    const linhas = this.dependenciasByCfgId?.[idConfiguracao] || [];
                    linhas.forEach(linha => {
                        const idDependencia = linha?.processoWorkflowDependencia?.idProcessoModeloArtefatoDependencia;
                        if (!idDependencia || !this.modelosById[idDependencia]) return;
                        if (!mapa[idModelo]) mapa[idModelo] = [];
                        if (!mapa[idModelo].includes(idDependencia)) mapa[idModelo].push(idDependencia);
                    });
                });
                return mapa;
            },
            graphEdges() {
                const edges = [];
                Object.keys(this.dependenciasPorModeloId).forEach(idModelo => {
                    this.dependenciasPorModeloId[idModelo].forEach(idDependencia => {
                        edges.push({ from: idDependencia, to: Number(idModelo) });
                    });
                });
                return edges;
            },
            gridPlacementById() {
                const map = {};
                this.idsModelosOrdenados.forEach((id, index) => {
                    map[id] = {
                        index,
                        row: Math.floor(index / this.orderColumns),
                        column: index % this.orderColumns
                    };
                });
                return map;
            },
            // Etapa que só depende das colunas/linhas: portas, canais e faixas.
            // Fica separada do posicionamento vertical porque as alturas dos vãos
            // são justamente derivadas da quantidade de faixas apurada aqui.
            planoRotasBase() {
                return this.montarPlanoRotas();
            },
            routedEdges() {
                return this.montarRotasFinais();
            },
            adjacencyByModeloId() {
                const graph = {};
                (this.modelosArtefatosWorkflow || []).forEach(m => {
                    const id = m.idProcessoModeloArtefato;
                    if (id != null && !graph[id]) {
                        graph[id] = [];
                    }
                });
                this.graphEdges.forEach(e => {
                    if (e.from == null || e.to == null) return;
                    if (!graph[e.from]) graph[e.from] = [];
                    if (!graph[e.from].includes(e.to)) {
                        graph[e.from].push(e.to);
                    }
                });

                return graph;
            },
            blockedDepsByModeloId() {
                const graph = this.adjacencyByModeloId;
                const blocked = {};
                const memo = {};

                const dfs = (start) => {
                    if (memo[start]) return memo[start];

                    const visited = new Set();
                    const stack = [start];

                    while (stack.length) {
                        const id = stack.pop();
                        const neighbours = graph[id] || [];
                        for (const nb of neighbours) {
                            if (!visited.has(nb)) {
                                visited.add(nb);
                                stack.push(nb);
                            }
                        }
                    }

                    memo[start] = visited;
                    return visited;
                };

                Object.keys(graph).forEach(k => {
                    const start = Number(k);
                    if (!start) return;
                    const set = dfs(start);
                    blocked[start] = Array.from(set);
                });

                return blocked;
            },
            selectedModeloId() {
                const cfg = this.cfgById[this.selectedConfigId];
                return cfg ? cfg.idProcessoModeloArtefato : null;
            },

            blockedModelIdsForSelected() {
                const modeloId = this.selectedModeloId;
                if (!modeloId) return [];
                const map = this.blockedDepsByModeloId || {};
                return map[modeloId] || [];
            },
            linhasGrade() {
                const columns = this.orderColumns;
                const ids = this.idsModelosOrdenados;
                const linhas = [];
                for (let inicio = 0; inicio < ids.length; inicio += columns) {
                    linhas.push(ids.slice(inicio, inicio + columns));
                }
                return linhas;
            },

            alturaPorLinha() {
                return this.linhasGrade.map(ids => Math.max(
                    this.nodeMinHeight,
                    ...ids.map(id => this.nodeHeightsMap[id] || this.nodeMinHeight)
                ));
            },

            // O vão abaixo de cada linha cresce conforme as faixas necessárias, de modo que
            // nenhum trecho horizontal precise ser espremido contra a borda dos cards.
            alturaVaoPorLinha() {
                const faixasPorVao = this.planoRotasBase.faixasPorVao;
                return this.linhasGrade.map((_, linha) => {
                    const faixas = faixasPorVao[linha] || 0;
                    if (!faixas) return this.vaoMinimo;
                    const necessario = this.faixaMargem * 2 + (faixas - 1) * this.faixaEspacamento;
                    return Math.max(this.vaoMinimo, necessario);
                });
            },

            positionsById() {
                const pos = {};
                const pad = this.canvasPadding;
                const nodeW = this.nodeWidthPx;
                const gap = this.otherRowsGap;
                const alturasLinha = this.alturaPorLinha;
                const alturasVao = this.alturaVaoPorLinha;
                let yCursor = pad;

                this.linhasGrade.forEach((idsLinha, linha) => {
                    idsLinha.forEach((id, coluna) => {
                        pos[id] = {
                            x: pad + coluna * (nodeW + gap),
                            y: yCursor
                        };
                    });
                    yCursor += alturasLinha[linha] + (alturasVao[linha] || this.vaoMinimo);
                });

                return pos;
            },

            metricasLinha() {
                return this.linhasGrade.map((ids, linha) => {
                    const topo = this.positionsById[ids[0]]?.y ?? this.canvasPadding;
                    return { topo, base: topo + this.alturaPorLinha[linha] };
                });
            },

            availableCanvasHeightPx() {
                const padBottom = 16;
                const rectTop = this.$refs.wfCanvas?.getBoundingClientRect?.().top || 0;
                const vh = this.viewport.h || window.innerHeight || 800;
                return Math.max(this.minCanvasHeight, Math.floor(vh - rectTop - padBottom));
            },

            user() {
                return this.$store.state.user
            },
            isAdmContrato() {
                return this.$store.state.isAdmContrato === 'Sim'
            },
            canAccess() {
                const u = this.user?.usuario
                return this.isAdmContrato || u?.idContrato === 0 || u?.dsLogin === 'aline.oliveira@negociospublicos.com.br' || this.user?.usuarioApi?.flAdministrador
            },

        },

        methods: {
            redirectToHome(msg) {
                avisoToast(msg || 'Fluxo não encontrado.', 'warning');
                if (this.$router) {
                    this.$router.replace({ name: 'Home' }).catch(() => {
                        this.$router.replace('/');
                    });
                } else {
                    window.location.href = '/';
                }
            },

            load() {
                if (!this.canAccess) {
                    this.$router.replace({ name: 'Home' })
                    return
                }
                this.getWorkflow();
            },

            getWorkflow() {
                var $this = this;
                $this.isLoading = true;
                var id = $this.$route.params.id;

                if (!id) {
                    $this.isLoading = false;
                    $this.hasWorkflow = false;
                    return $this.redirectToHome('ID de fluxo ausente.');
                }

                axios.get(urlApi + '/ProcessoWorkflow/GetWorkflow/' + id)
                    .then(function (res) {
                        var ok = res.data.success;
                        var pwf = res.data.data.processoWorkflow;

                        if (!ok || !pwf || !pwf.idProcessoWorkflow) {
                            $this.hasWorkflow = false;
                            return $this.redirectToHome('Fluxo não encontrado ou inválido.');
                        }

                        $this.workflow = pwf;
                        $this.nomeWorkflowEditado = pwf.nmProcessoWorkflow || '';
                        $this.workflowLegislacao = res.data.data.legislacao;
                        $this.workflowTipoProcesso = res.data.data.tipoProcesso;
                        $this.idLegislacao = pwf.idLegislacao;
                        $this.idTipoProcesso = pwf.idTipoProcesso;
                        $this.hasWorkflow = true;

                        Promise.all([
                            $this.getModelosProcesso(),
                            $this.getWorkflowConfiguracao(pwf.idProcessoWorkflow)
                        ]).then(async function () {
                            await $this.checkAndBootstrap();
                            await $this.fetchAllDependenciasIfNeeded();
                        }).catch(function () {
                            avisoErro('Erro ao carregar modelos/configurações.');
                        });

                    })
                    .catch(function (err) {
                        if (err.response && err.response.data) avisoErro(err.response.data);
                        avisoToast('Erro ao carregar fluxo!', 'warning');

                        $this.hasWorkflow = false;
                        $this.redirectToHome('Não foi possível carregar o fluxo.');
                    })
                    .finally(function () {
                        $this.isLoading = false;
                    });
            },

            async salvarNomeWorkflow() {
                if (!this.podeSalvarNomeWorkflow) return;

                const nome = this.nomeWorkflowEditado.trim();
                this.salvandoNomeWorkflow = true;
                try {
                    const resposta = await axios.post(`${urlApi}/ProcessoWorkflow/PostWorkflow`, {
                        DadosProcessoWorkflow: {
                            idProcessoWorkflow: this.workflow.idProcessoWorkflow,
                            idTipoProcesso: this.workflow.idTipoProcesso,
                            idLegislacao: this.workflow.idLegislacao,
                            nmProcessoWorkflow: nome
                        }
                    });

                    if (!resposta.data?.success)
                        throw new Error(resposta.data?.msg || 'Não foi possível alterar o nome do fluxo.');

                    this.workflow.nmProcessoWorkflow = nome;
                    avisoToast('Nome do fluxo atualizado.', 'success');
                } catch (erro) {
                    const api = erro?.response?.data;
                    const mensagem =
                        (Array.isArray(api?.errors) && api.errors.length ? api.errors[0] : null) ||
                        api?.msg ||
                        erro?.message ||
                        'Não foi possível alterar o nome do fluxo.';
                    avisoErro(mensagem);
                } finally {
                    this.salvandoNomeWorkflow = false;
                }
            },

            getWorkflowConfiguracao(idProcessoWorkflow) {
                var $this = this;
                return axios.get(urlApi + '/ProcessoWorkflow/GetWorkflowArtefato', {
                    params: { idProcessoWorkflow: idProcessoWorkflow }
                })
                    .then(function (res) {
                        if (res.data && res.data.success && res.data.data && Array.isArray(res.data.data.rows)) {
                            $this.workflowConfig = res.data.data.rows
                                .map(r => r.processoWorkflowArtefato)
                                .filter(x => !!x && x.idProcessoWorkflowArtefato);
                        } else {
                            $this.workflowConfig = [];
                        }
                    })
                    .catch(function (err) {
                        $this.workflowConfig = [];
                        if (err.response && err.response.data) {
                            avisoErro(err.response.data);
                            avisoToast('Erro ao carregar configurações do fluxo!', 'warning');
                        } else {
                            avisoErro(err.message || 'Erro desconhecido');
                        }
                    });
            },

            getWorkflowDependencia(idProcessoWorkflowArtefato) {
                return axios.get(urlApi + '/ProcessoWorkflow/GetWorkflowDependencia', {
                    params: { idProcessoWorkflowArtefato }
                });
            },

            async fetchAllDependenciasIfNeeded() {
                this.dependenciasByCfgId = {};
                if (!Array.isArray(this.workflowConfig) || this.workflowConfig.length === 0) return;

                this.loadingDeps = true;
                try {
                    const calls = this.workflowConfig
                        .filter(cfg => cfg?.idProcessoWorkflowArtefato && cfg.flDependencia === true)
                        .map(async (cfg) => {
                            try {
                                const res = await this.getWorkflowDependencia(cfg.idProcessoWorkflowArtefato);
                                const rows = res.data.data.rows || [];
                                this.$set(this.dependenciasByCfgId, cfg.idProcessoWorkflowArtefato, rows);
                            } catch {
                                this.$set(this.dependenciasByCfgId, cfg.idProcessoWorkflowArtefato, []);
                            }
                        });
                    await Promise.all(calls);
                } finally {
                    this.loadingDeps = false;
                }
            },

            getModelosProcesso() {
                var $this = this;
                return axios.get(urlApi + '/ProcessoModeloArtefato/GetModelosWorkflow', {
                    showLoading: true,
                    params: {
                        idLegislacao: $this.idLegislacao,
                        idTipoProcesso: $this.idTipoProcesso,
                        idProcessoWorkflow: $this.workflow.idProcessoWorkflow
                    }
                })
                    .then(function (res) {
                        if (res.data && res.data.success) {
                            var result = res.data.data.rows;
                            $this.modelosArtefatosWorkflow = result.map(function (r) {
                                var item = r && r.item ? r.item : r;
                                return {
                                    idProcessoModeloArtefato: item.idProcessoModeloArtefato,
                                    nmModelo: item.nmModelo,
                                    cdModelo: item.cdModelo,
                                    nmIcone: item.nmIcone,
                                    idCliente: item.idCliente,
                                    idProcessoWorkflow: item.idProcessoWorkflow,
                                    nrOrdem: item.nrOrdem
                                };
                            });
                        } else { avisoErro(res.data.msg || 'Erro ao carregar processo.'); }
                    }).catch(err => { avisoErro(err?.response?.data || err.message || 'Erro desconhecido'); });
            },

            async checkAndBootstrap() {
                var precisaBootstrap = !this.workflowConfig || (Array.isArray(this.workflowConfig) && this.workflowConfig.length === 0);
                if (!precisaBootstrap || this.isBootstrapping) return;
                await this.$nextTick();
                this.showFirstStepsModal();
                // Aguardar evita que a busca de dependências rode antes das configurações
                // existirem e que uma segunda entrada na tela dispare um bootstrap paralelo.
                await this.createAllInitialConfigs();
            },

            showFirstStepsModal() {
                this.isBootstrapping = true;
                this.loadingPostAutomatico = true;
                this.bootstrapProgress.total = this.modelosArtefatosWorkflow.length;
                this.bootstrapProgress.done = 0;
                this.bootstrapProgress.errorCount = 0;

                var el = document.getElementById('ModalFirstStepsWorkflow');
                if (!el) return;

                var bs = window.bootstrap || window.Bootstrap || null;
                if (bs && bs.Modal) {
                    if (this.firstStepsModal) {
                        this.firstStepsModal.dispose();
                        this.firstStepsModal = null;
                    }
                    this.firstStepsModal = new bs.Modal(el, { backdrop: 'static', keyboard: false });
                    this.firstStepsModal.show();
                    el.addEventListener('hide.bs.modal', (e) => {
                        if (this.loadingPostAutomatico) {
                            e.preventDefault();
                        }
                    });
                } else if (window.$ && typeof window.$.fn !== 'undefined' && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal({ backdrop: 'static', keyboard: false, show: true });
                }
            },

            setFirstStepsModalClosable(closable) {
                var el = document.getElementById('ModalFirstStepsWorkflow');
                if (!el) return;

                var bs = window.bootstrap || window.Bootstrap || null;
                if (bs && bs.Modal) {
                    if (this.firstStepsModal) {
                        this.firstStepsModal.dispose();
                        this.firstStepsModal = null;
                    }
                    this.firstStepsModal = new bs.Modal(el, {
                        backdrop: closable ? true : 'static',
                        keyboard: !!closable
                    });
                    this.firstStepsModal.show();
                } else if (window.$ && typeof window.$.fn !== 'undefined' && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal('dispose');
                    window.$(el).modal({ backdrop: closable ? true : 'static', keyboard: !!closable, show: true });
                }
            },

            hideFirstStepsModal() {
                if (this.firstStepsModal && typeof this.firstStepsModal.hide === 'function') {
                    this.firstStepsModal.hide();
                } else {
                    var el = document.getElementById('ModalFirstStepsWorkflow');
                    if (el && window.$ && typeof window.$.fn !== 'undefined' && typeof window.$.fn.modal === 'function') {
                        window.$(el).modal('hide');
                    }
                }
                this.isBootstrapping = false;
            },

            createInitialConfigForModel(modelo) {
                let $this = this;
                let possuiDependenciaMapaRisco = $this.modelosArtefatosWorkflow.filter(x => x.cdModelo == 1 || x.cdModelo == 2 || x.cdModelo == 3).length == 3;
                var payload = {
                    DadosProcessoWorkflowArtefato: {
                        idProcessoWorkflow: this.workflow.idProcessoWorkflow,
                        idProcessoModeloArtefato: modelo.idProcessoModeloArtefato,
                        flDependencia: (possuiDependenciaMapaRisco && modelo.cdModelo == 3 ? true : false),
                        flPrazo: false,
                        flAprovacao: false,
                        flRevisao: false,
                        flAssinatura: false,
                        flAtivo: true,
                        nrOrdem: modelo.nrOrdem ?? (this.modelosArtefatosWorkflow.findIndex(
                            item => item.idProcessoModeloArtefato === modelo.idProcessoModeloArtefato
                        ) + 1),
                        nrDiasPrazo: null,
                        tpDiasPrazo: null,

                    }
                };

                return axios.post(`${urlApi}/ProcessoWorkflow/PostWorkflowArtefato`, payload, { showLoading: false }).then(res => {
                    if (res.data.success) {
                        let idProcessoWorkflowArtefato = res.data.data;
                        // se modelo for Mapa de Riscos
                        if (possuiDependenciaMapaRisco && modelo.cdModelo == 3) {
                            // gera dependencia de DFD
                            var depModeloId = $this.modelosArtefatosWorkflow.find(x => x.cdModelo == 1);
                            if (depModeloId) {
                                try {
                                    axios.post(`${urlApi}/ProcessoWorkflow/PostWorkflowDependencia`, {
                                        DadosProcessoWorkflowDependencia: {
                                            idProcessoWorkflowDependencia: 0,
                                            idProcessoWorkflowArtefato: idProcessoWorkflowArtefato,
                                            idProcessoModeloArtefato: modelo.idProcessoModeloArtefato,
                                            idProcessoModeloArtefatoDependencia: depModeloId.idProcessoModeloArtefato
                                        }
                                    }, { showLoading: false }).then(function () {
                                        // gera dependencia de ETP
                                        depModeloId = $this.modelosArtefatosWorkflow.find(x => x.cdModelo == 2);
                                        if (depModeloId) {
                                            try {
                                                axios.post(`${urlApi}/ProcessoWorkflow/PostWorkflowDependencia`, {
                                                    DadosProcessoWorkflowDependencia: {
                                                        idProcessoWorkflowDependencia: 0,
                                                        idProcessoWorkflowArtefato: idProcessoWorkflowArtefato,
                                                        idProcessoModeloArtefato: modelo.idProcessoModeloArtefato,
                                                        idProcessoModeloArtefatoDependencia: depModeloId.idProcessoModeloArtefato
                                                    }
                                                }, { showLoading: false }).then(function () {
                                                    $this.refreshConfigs();
                                                });
                                            } catch (e) {
                                                console.warn('Falha ao criar dependência para modelo', depModeloId, e);
                                            }
                                        }
                                    });
                                } catch (e) {
                                    console.warn('Falha ao criar dependência para modelo', depModeloId, e);
                                }
                            }
                        }
                    }
                })
            },

            getNodePos(id) {
                return this.manualPositions[id] || this.positionsById[id] || { x: 0, y: 0 };
            },

            iniciarOrganizacaoOrdem() {
                if (!this.isWorkflowAtivo || this.loadingDeps) return;
                const ordem = this.empilharInativosNoFim([...this.idsModelosOrdenados]);
                const ordemValida = this.empilharInativosNoFim(this.normalizarOrdemPorDependencias(ordem));
                this.ordemOriginal = ordem;
                this.ordemRascunho = ordemValida;
                this.manualPositions = {};
                this.ordemAlterada = ordemValida.some((id, index) => id !== ordem[index]);
                this.organizandoOrdem = true;
                if (this.ordemAlterada) {
                    avisoToast('A ordem foi ajustada para manter as dependências antes dos artefatos dependentes.', 'warning');
                }
            },

            cancelarOrganizacaoOrdem() {
                if (this.salvandoOrdem) return;
                this.ordemRascunho = [...this.ordemOriginal];
                this.manualPositions = {};
                this.ordemAlterada = false;
                this.organizandoOrdem = false;
            },

            empilharInativosNoFim(idsModelo) {
                const ativos = [];
                const inativos = [];
                idsModelo.forEach(id => {
                    if (this.cfgByModeloId[id]?.flAtivo === false) inativos.push(id);
                    else ativos.push(id);
                });
                return [...ativos, ...inativos];
            },

            ordemRespeitaDependencias(idsModelo) {
                const posicoes = new Map(idsModelo.map((id, index) => [Number(id), index]));
                return this.graphEdges.every(edge => {
                    const posDependencia = posicoes.get(Number(edge.from));
                    const posDependente = posicoes.get(Number(edge.to));
                    return posDependencia == null || posDependente == null || posDependencia < posDependente;
                });
            },

            normalizarOrdemPorDependencias(idsModelo) {
                const prioridade = new Map(idsModelo.map((id, index) => [Number(id), index]));
                const grauEntrada = new Map(idsModelo.map(id => [Number(id), 0]));
                const saidas = new Map(idsModelo.map(id => [Number(id), []]));

                this.graphEdges.forEach(edge => {
                    const origem = Number(edge.from);
                    const destino = Number(edge.to);
                    if (!grauEntrada.has(origem) || !grauEntrada.has(destino)) return;
                    saidas.get(origem).push(destino);
                    grauEntrada.set(destino, grauEntrada.get(destino) + 1);
                });

                const disponiveis = idsModelo
                    .map(Number)
                    .filter(id => grauEntrada.get(id) === 0)
                    .sort((a, b) => prioridade.get(a) - prioridade.get(b));
                const resultado = [];

                while (disponiveis.length) {
                    const atual = disponiveis.shift();
                    resultado.push(atual);
                    (saidas.get(atual) || []).forEach(destino => {
                        grauEntrada.set(destino, grauEntrada.get(destino) - 1);
                        if (grauEntrada.get(destino) === 0) {
                            disponiveis.push(destino);
                            disponiveis.sort((a, b) => prioridade.get(a) - prioridade.get(b));
                        }
                    });
                }

                return resultado.length === idsModelo.length ? resultado : [...idsModelo];
            },

            async salvarOrdem() {
                if (!this.ordemAlterada || this.salvandoOrdem) return;
                this.ordemRascunho = this.empilharInativosNoFim(this.ordemRascunho);
                if (!this.ordemRespeitaDependencias(this.ordemRascunho)) {
                    avisoToast('A ordem deve manter cada dependência antes do artefato dependente.', 'warning');
                    return;
                }

                const idsConfiguracao = this.ordemRascunho.map(idModelo =>
                    this.cfgByModeloId[idModelo]?.idProcessoWorkflowArtefato
                );
                if (idsConfiguracao.some(id => !id)) {
                    avisoErro('Não foi possível localizar todas as configurações do workflow.');
                    return;
                }

                this.salvandoOrdem = true;
                try {
                    await axios.post(`${urlApi}/ProcessoWorkflow/PostWorkflowArtefatoOrdem`, {
                        idProcessoWorkflow: this.workflow.idProcessoWorkflow,
                        idsProcessoWorkflowArtefato: idsConfiguracao
                    }, { showLoading: false });

                    await this.getWorkflowConfiguracao(this.workflow.idProcessoWorkflow);
                    this.ordemOriginal = [...this.idsModelosOrdenados];
                    this.ordemRascunho = [];
                    this.manualPositions = {};
                    this.ordemAlterada = false;
                    this.organizandoOrdem = false;
                    avisoToast('Ordem do workflow salva com sucesso.', 'success');
                } catch (e) {
                    const api = e?.response?.data;
                    const mensagem =
                        (Array.isArray(api?.errors) && api.errors.length ? api.errors[0] : null) ||
                        api?.msg ||
                        'Não foi possível salvar a ordem do workflow.';
                    avisoErro(mensagem);
                } finally {
                    this.salvandoOrdem = false;
                }
            },

            async createAllInitialConfigs() {
                try {
                    var total = this.modelosArtefatosWorkflow.length;
                    this.bootstrapProgress.total = total;
                    this.bootstrapProgress.done = 0;
                    this.bootstrapProgress.errorCount = 0;

                    for (var i = 0; i < total; i++) {
                        var m = this.modelosArtefatosWorkflow[i];
                        try {
                            await this.createInitialConfigForModel(m);
                            this.bootstrapProgress.done = this.bootstrapProgress.done + 1;
                        } catch (e) {
                            this.bootstrapProgress.done = this.bootstrapProgress.done + 1;
                            this.bootstrapProgress.errorCount = this.bootstrapProgress.errorCount + 1;
                        }
                    }

                    await this.getWorkflowConfiguracao(this.workflow.idProcessoWorkflow);
                    this.loadingPostAutomatico = false;
                    this.setFirstStepsModalClosable(true);
                    avisoToast('Configuração inicial criada com sucesso.', 'success');

                } catch (err) {
                    this.loadingPostAutomatico = false;
                    this.setFirstStepsModalClosable(true);
                    avisoErro('Falha ao criar configuração inicial.');
                }
            },

            handleOpenModalGeral() {
                if (!this.isWorkflowAtivo) {
                    avisoToast('Este fluxo está inativo. A visualização é somente leitura.', 'warning');
                    return;
                }
                this.openModalGeral();
            },

            openModalGeral() {
                if (this.workflowConfig && this.workflowConfig.length > 0) {
                    const c0 = this.workflowConfig[0];

                    this.geralForm.flPrazo = c0.flPrazo === true;
                    this.geralForm.flRevisao = c0.flRevisao === true;
                    this.geralForm.flAprovacao = c0.flAprovacao === true;
                    this.geralForm.flAssinatura = c0.flAssinatura === true;

                    if (this.geralForm.flPrazo) {
                        this.geralForm.nrDiasPrazo = (typeof c0.nrDiasPrazo === 'number')
                            ? c0.nrDiasPrazo
                            : (c0.nrDiasPrazo ? parseInt(c0.nrDiasPrazo) : null);
                        this.geralForm.tpDiasPrazo = c0.tpDiasPrazo || 'CRD';
                    } else {
                        this.geralForm.nrDiasPrazo = null;
                        this.geralForm.tpDiasPrazo = 'CRD';
                    }
                }

                const el = document.getElementById('ModalWorkflowGeral');
                if (!el) return;

                const bs = window.bootstrap || window.Bootstrap || null;
                if (bs?.Modal) {
                    this.modalGeral = bs.Modal.getOrCreateInstance(el);
                    this.modalGeral.show();
                } else if (window.$?.fn?.modal) {
                    window.$(el).modal({
                        backdrop: true,
                        keyboard: true,
                        show: true
                    });
                }
            },

            validateGeralForm() {
                if (this.geralForm.flPrazo === true) {
                    if (typeof this.geralForm.nrDiasPrazo !== 'number' ||
                        isNaN(this.geralForm.nrDiasPrazo) ||
                        this.geralForm.nrDiasPrazo < 0) {
                        avisoErro('Informe um número de dias válido.');
                        return false;
                    }

                    if (!this.geralForm.tpDiasPrazo ||
                        (this.geralForm.tpDiasPrazo !== 'CRD' && this.geralForm.tpDiasPrazo !== 'UTS')) {
                        avisoErro('Selecione o tipo de dias (CRD/UTS).');
                        return false;
                    }
                }

                return true;
            },

            async saveModalGeral() {
                if (!this.isWorkflowAtivo) {
                    avisoToast('Este fluxo está inativo. Não é possível salvar alterações.', 'warning');
                    return;
                }
                if (!this.validateGeralForm()) return;

                this.savingGeral = true;
                this.geralProgress.total = this.workflowConfig.length;
                this.geralProgress.done = 0;
                this.geralProgress.errorCount = 0;

                try {
                    const el = document.getElementById('ModalWorkflowGeral');
                    const bs = window.bootstrap || window.Bootstrap || null;
                    if (bs?.Modal && el) {
                        this.modalGeral = bs.Modal.getOrCreateInstance(el);
                    }
                    for (let i = 0; i < this.workflowConfig.length; i++) {
                        const cfg = this.workflowConfig[i];
                        if (!cfg?.idProcessoWorkflowArtefato) {
                            this.geralProgress.done++;
                            this.geralProgress.errorCount++;
                            continue;
                        }
                        const body = {
                            DadosProcessoWorkflowArtefato: {
                                idProcessoWorkflowArtefato: cfg.idProcessoWorkflowArtefato,
                                idProcessoWorkflow: this.workflow.idProcessoWorkflow,
                                idProcessoModeloArtefato: cfg.idProcessoModeloArtefato,
                                flPrazo: this.geralForm.flPrazo,
                                flRevisao: this.isArtefatoAdicionadoPeloCliente(cfg.idProcessoModeloArtefato)
                                    ? false
                                    : this.geralForm.flRevisao,
                                flAprovacao: this.isArtefatoAdicionadoPeloCliente(cfg.idProcessoModeloArtefato)
                                    ? false
                                    : this.geralForm.flAprovacao,
                                flAssinatura: this.geralForm.flAssinatura,
                                nrDiasPrazo: this.geralForm.flPrazo ? this.geralForm.nrDiasPrazo : null,
                                tpDiasPrazo: this.geralForm.flPrazo ? this.geralForm.tpDiasPrazo : null,
                                tpInicioPrazo: 'INICIO',
                                flDependencia: (typeof cfg.flDependencia === 'boolean') ? cfg.flDependencia : false,
                            },
                        };

                        try {
                            await axios.post(urlApi + '/ProcessoWorkflow/PostWorkflowArtefato', body, { showLoading: false });
                        } catch (e) {
                            this.geralProgress.errorCount++;
                        } finally {
                            this.geralProgress.done++;
                            await this.$nextTick();
                        }
                    }
                    await this.getWorkflowConfiguracao(this.workflow.idProcessoWorkflow);
                    await this.fetchAllDependenciasIfNeeded();
                    this.savingGeral = false;
                    if (this.modalGeral && el && bs && bs.Modal) {
                        this.modalGeral.dispose();
                        this.modalGeral = new bs.Modal(el, { backdrop: true, keyboard: true });
                        this.modalGeral.show();
                    }
                    if (this.geralProgress.errorCount > 0) {
                        avisoToast(`Aplicado com ${this.geralProgress.errorCount} falha(s).`, 'warning');
                    } else {
                        avisoToast('Configurações aplicadas a todos os artefatos.', 'success');
                    }

                } catch (err) {
                    this.savingGeral = false;
                    avisoErro('Falha ao aplicar configurações gerais.');
                }
            },

            tipoDiasLabel(tp) {
                if (tp === 'UTS') return 'úteis';
                if (tp === 'CRD') return 'corridos';
                return tp || '-';
            },

            async refreshConfigs() {
                if (!this.workflow || !this.workflow.idProcessoWorkflow) return;
                await this.getWorkflowConfiguracao(this.workflow.idProcessoWorkflow);
                await this.fetchAllDependenciasIfNeeded();
            },

            abrirModalNovoArtefato() {
                if (!this.isWorkflowAtivo || this.organizandoOrdem) return;
                this.$refs.modalNovoArtefato?.abrir();
            },

            async onNovoArtefatoSalvo() {
                if (!this.workflow?.idProcessoWorkflow) return;
                await Promise.all([
                    this.getModelosProcesso(),
                    this.getWorkflowConfiguracao(this.workflow.idProcessoWorkflow)
                ]);
                await this.fetchAllDependenciasIfNeeded();
                this.$nextTick(() => {
                    this.medirAlturasDosCards();
                });
            },

            async onArtefatoRenomeado() {
                await this.onNovoArtefatoSalvo();
            },

            openModelo(m) {
                if (!this.isWorkflowAtivo) {
                    avisoToast('Este fluxo está inativo. A visualização é somente leitura.', 'warning');
                    return;
                }
                const cfg = this.cfgByModeloId?.[m.idProcessoModeloArtefato]
                if (!cfg?.idProcessoWorkflowArtefato) {
                    return avisoErro('Configuração não encontrada para este modelo.')
                }
                this.selectedConfigId = Number(cfg.idProcessoWorkflowArtefato)

                this.$nextTick(() => {
                    const el = document.getElementById('ModalWorkflowConfiguracao')
                    const bs = window.bootstrap || window.Bootstrap || null
                    if (bs?.Modal) bs.Modal.getOrCreateInstance(el).show()
                    else if (window.$?.fn?.modal) window.$(el).modal('show')
                })
            },

            openModeloById(modeloId) {
                if (!this.isWorkflowAtivo) {
                    avisoToast('Este fluxo está inativo. A visualização é somente leitura.', 'warning');
                    return;
                }
                const m = this.modelosById?.[modeloId];
                if (!m) return avisoErro('Modelo não encontrado.');
                const cfg = this.cfgByModeloId?.[modeloId];
                if (!cfg?.idProcessoWorkflowArtefato) return avisoErro('Configuração não encontrada para este modelo.');
                this.selectedConfigId = Number(cfg.idProcessoWorkflowArtefato);
                this.$nextTick(() => {
                    const el = document.getElementById('ModalWorkflowConfiguracao');
                    const bs = window.bootstrap || window.Bootstrap || null;
                    if (bs?.Modal) bs.Modal.getOrCreateInstance(el).show();
                    else if (window.$?.fn?.modal) window.$(el).modal('show');
                });
            },

            depModeloNomesByModeloId(modeloId) {
                return (this.dependenciasPorModeloId[modeloId] || [])
                    .map(id => this.modelosById?.[id]?.nmModelo)
                    .filter(Boolean);
            },

            colunaXPx(coluna) {
                return this.canvasPadding + coluna * (this.nodeWidthPx + this.otherRowsGap);
            },

            portaXPx(x, largura, fracao) {
                const recuo = 34;
                const util = Math.max(1, largura - recuo * 2);
                return x + recuo + util * fracao;
            },

            // Corredor vertical livre. Índices negativos e acima da última coluna
            // caem nas margens do canvas, que também são espaço livre.
            corredorXPx(corredor, indice, total) {
                const colunas = this.orderColumns;
                let base;
                if (corredor < 0) {
                    base = this.canvasPadding / 2;
                } else if (corredor >= colunas - 1) {
                    base = this.colunaXPx(colunas - 1) + this.nodeWidthPx + this.canvasPadding / 2;
                } else {
                    base = this.colunaXPx(corredor) + this.nodeWidthPx + this.otherRowsGap / 2;
                }

                const largura = corredor >= 0 && corredor < colunas - 1
                    ? this.otherRowsGap - 16
                    : Math.max(24, this.canvasPadding - 12);
                const espacamento = Math.min(this.faixaEspacamento, largura / Math.max(1, total));
                return base + (indice - (total - 1) / 2) * espacamento;
            },

            montarPlanoRotas() {
                const vazio = { registros: [], faixasPorVao: {} };
                const colunas = this.orderColumns;
                const larguraNode = this.nodeWidthPx;

                const registros = this.graphEdges
                    .map(edge => {
                        const de = this.gridPlacementById[edge.from];
                        const para = this.gridPlacementById[edge.to];
                        if (!de || !para) return null;
                        return {
                            ...edge,
                            key: `${edge.from}-${edge.to}`,
                            label: `${this.modelosById[edge.from]?.nmModelo || edge.from} → ${this.modelosById[edge.to]?.nmModelo || edge.to}`,
                            de,
                            para
                        };
                    })
                    .filter(Boolean)
                    .sort((a, b) => a.de.index - b.de.index || a.para.index - b.para.index);

                if (!registros.length) return vazio;

                registros.forEach(rota => {
                    const mesmaLinha = rota.de.row === rota.para.row;
                    if (mesmaLinha && rota.para.column === rota.de.column + 1) rota.tipo = 'lateral';
                    else if (mesmaLinha) rota.tipo = 'mesmaLinha';
                    else if (rota.para.row > rota.de.row) rota.tipo = 'desce';
                    else rota.tipo = 'sobe';
                });

                const definirIndices = (lista, chave, comparar, nomeIndice, nomeTotal) => {
                    const grupos = {};
                    lista.forEach(item => {
                        const k = chave(item);
                        if (!grupos[k]) grupos[k] = [];
                        grupos[k].push(item);
                    });
                    Object.values(grupos).forEach(grupo => {
                        grupo.sort(comparar);
                        grupo.forEach((item, indice) => {
                            item[nomeIndice] = indice;
                            item[nomeTotal] = grupo.length;
                        });
                    });
                };

                // Vizinhos imediatos da mesma linha são ligados de lado a lado, sem faixa.
                const roteadas = registros.filter(rota => rota.tipo !== 'lateral');

                definirIndices(roteadas, r => r.from, (a, b) => a.para.index - b.para.index, 'idxSaida', 'totSaida');
                definirIndices(roteadas, r => r.to, (a, b) => a.de.index - b.de.index, 'idxEntrada', 'totEntrada');

                // A fração é guardada para que o traçado acompanhe o card durante o
                // arraste, enquanto o X da grade é usado para distribuir as faixas.
                roteadas.forEach(rota => {
                    rota.fracaoSaida = (rota.idxSaida + 1) / (rota.totSaida + 1);
                    rota.fracaoEntrada = (rota.idxEntrada + 1) / (rota.totEntrada + 1);
                    rota.saidaX = this.portaXPx(this.colunaXPx(rota.de.column), larguraNode, rota.fracaoSaida);
                    rota.entradaX = this.portaXPx(this.colunaXPx(rota.para.column), larguraNode, rota.fracaoEntrada);
                });

                // Só quem precisa atravessar linhas usa corredor vertical.
                const comCorredor = roteadas.filter(rota =>
                    rota.tipo === 'sobe' || (rota.tipo === 'desce' && rota.para.row > rota.de.row + 1)
                );
                comCorredor.forEach(rota => {
                    const menor = Math.min(rota.de.column, rota.para.column);
                    rota.corredor = menor < colunas - 1 ? menor : menor - 1;
                });
                definirIndices(
                    comCorredor,
                    r => r.corredor,
                    (a, b) => Math.min(a.de.row, a.para.row) - Math.min(b.de.row, b.para.row) || a.de.index - b.de.index,
                    'idxCorredor',
                    'totCorredor'
                );
                comCorredor.forEach(rota => {
                    rota.corredorX = this.corredorXPx(rota.corredor, rota.idxCorredor, rota.totCorredor);
                });

                const segmentos = [];
                const registrarSegmento = (rota, vao, campo, xA, xB) => {
                    segmentos.push({
                        rota,
                        vao,
                        campo,
                        x1: Math.min(xA, xB),
                        x2: Math.max(xA, xB)
                    });
                };

                roteadas.forEach(rota => {
                    if (rota.corredorX == null) {
                        rota.vaoSaida = rota.de.row;
                        registrarSegmento(rota, rota.vaoSaida, 'faixaSaida', rota.saidaX, rota.entradaX);
                        return;
                    }
                    rota.vaoSaida = rota.de.row;
                    rota.vaoEntrada = rota.tipo === 'desce' ? rota.para.row - 1 : rota.para.row;
                    registrarSegmento(rota, rota.vaoSaida, 'faixaSaida', rota.saidaX, rota.corredorX);
                    registrarSegmento(rota, rota.vaoEntrada, 'faixaEntrada', rota.corredorX, rota.entradaX);
                });

                // Empacota os trechos horizontais de cada vão: trechos que não se
                // sobrepõem no eixo X dividem a mesma faixa, e os mais longos ficam
                // nas faixas mais afastadas dos cards.
                const faixasPorVao = {};
                const porVao = {};
                segmentos.forEach(segmento => {
                    if (!porVao[segmento.vao]) porVao[segmento.vao] = [];
                    porVao[segmento.vao].push(segmento);
                });

                Object.keys(porVao).forEach(chave => {
                    const lista = porVao[chave].slice()
                        .sort((a, b) => (b.x2 - b.x1) - (a.x2 - a.x1) || a.x1 - b.x1);
                    const faixas = [];

                    lista.forEach(segmento => {
                        let alvo = faixas.findIndex(intervalos => intervalos.every(intervalo =>
                            segmento.x2 + this.faixaSeparacao < intervalo.x1 ||
                            segmento.x1 - this.faixaSeparacao > intervalo.x2
                        ));
                        if (alvo === -1) {
                            faixas.push([]);
                            alvo = faixas.length - 1;
                        }
                        faixas[alvo].push({ x1: segmento.x1, x2: segmento.x2 });
                        segmento.faixa = alvo;
                    });

                    const ordenadas = faixas
                        .map((intervalos, indice) => ({
                            indice,
                            extensao: Math.max(...intervalos.map(intervalo => intervalo.x2 - intervalo.x1))
                        }))
                        .sort((a, b) => a.extensao - b.extensao);
                    const remapeada = {};
                    ordenadas.forEach((item, novoIndice) => { remapeada[item.indice] = novoIndice; });

                    lista.forEach(segmento => { segmento.rota[segmento.campo] = remapeada[segmento.faixa]; });
                    faixasPorVao[Number(chave)] = faixas.length;
                });

                return { registros, faixasPorVao };
            },

            faixaYPx(vao, indice) {
                const metrica = this.metricasLinha[vao];
                const base = metrica ? metrica.base : this.canvasPadding + this.nodeMinHeight;
                return base + this.faixaMargem + (indice || 0) * this.faixaEspacamento;
            },

            montarRotasFinais() {
                // A ponta da seta para um pouco antes da borda para não ficar
                // encoberta pelo card, que é desenhado acima do SVG.
                const recuoSeta = 4;

                return this.planoRotasBase.registros.map(rota => {
                    const caixaDe = this.getNodeBox(rota.from);
                    const caixaPara = this.getNodeBox(rota.to);
                    if (!caixaDe || !caixaPara) return null;

                    let pontos;

                    if (rota.tipo === 'lateral') {
                        const y = Math.min(caixaDe.y, caixaPara.y) + Math.min(caixaDe.h, caixaPara.h) / 2;
                        pontos = [
                            { x: caixaDe.x + caixaDe.w, y },
                            { x: caixaPara.x - recuoSeta, y }
                        ];
                    } else {
                        const saidaX = this.portaXPx(caixaDe.x, caixaDe.w, rota.fracaoSaida);
                        const entradaX = this.portaXPx(caixaPara.x, caixaPara.w, rota.fracaoEntrada);
                        const inicio = { x: saidaX, y: caixaDe.y + caixaDe.h };
                        const fim = rota.tipo === 'desce'
                            ? { x: entradaX, y: caixaPara.y - recuoSeta }
                            : { x: entradaX, y: caixaPara.y + caixaPara.h + recuoSeta };
                        const ySaida = this.faixaYPx(rota.vaoSaida, rota.faixaSaida);

                        if (rota.corredorX == null) {
                            pontos = [
                                inicio,
                                { x: inicio.x, y: ySaida },
                                { x: fim.x, y: ySaida },
                                fim
                            ];
                        } else {
                            const yEntrada = this.faixaYPx(rota.vaoEntrada, rota.faixaEntrada);
                            pontos = [
                                inicio,
                                { x: inicio.x, y: ySaida },
                                { x: rota.corredorX, y: ySaida },
                                { x: rota.corredorX, y: yEntrada },
                                { x: fim.x, y: yEntrada },
                                fim
                            ];
                        }
                    }

                    const normalizados = this.normalizeOrthogonalPoints(pontos);
                    return {
                        ...rota,
                        points: normalizados,
                        path: this.roundedOrthogonalPath(normalizados, this.edgeCornerRadius),
                        maxX: Math.max(...normalizados.map(ponto => ponto.x)),
                        maxY: Math.max(...normalizados.map(ponto => ponto.y))
                    };
                }).filter(Boolean);
            },

            normalizeOrthogonalPoints(points) {
                const unique = points.filter((point, index) =>
                    index === 0 ||
                    point.x !== points[index - 1].x ||
                    point.y !== points[index - 1].y
                );
                if (unique.length <= 2) return unique;

                const normalized = [unique[0]];
                for (let index = 1; index < unique.length - 1; index++) {
                    const previous = normalized[normalized.length - 1];
                    const current = unique[index];
                    const next = unique[index + 1];
                    const sameX = previous.x === current.x && current.x === next.x;
                    const sameY = previous.y === current.y && current.y === next.y;
                    if (!sameX && !sameY) normalized.push(current);
                }
                normalized.push(unique[unique.length - 1]);
                return normalized;
            },

            roundedOrthogonalPath(points, radius) {
                if (!points.length) return '';
                if (points.length === 1) return `M ${points[0].x} ${points[0].y}`;

                let path = `M ${points[0].x} ${points[0].y}`;
                for (let index = 1; index < points.length - 1; index++) {
                    const previous = points[index - 1];
                    const current = points[index];
                    const next = points[index + 1];
                    const incoming = Math.hypot(current.x - previous.x, current.y - previous.y);
                    const outgoing = Math.hypot(next.x - current.x, next.y - current.y);
                    const cornerRadius = Math.min(radius, incoming / 2, outgoing / 2);
                    const before = {
                        x: current.x + (previous.x - current.x) / incoming * cornerRadius,
                        y: current.y + (previous.y - current.y) / incoming * cornerRadius
                    };
                    const after = {
                        x: current.x + (next.x - current.x) / outgoing * cornerRadius,
                        y: current.y + (next.y - current.y) / outgoing * cornerRadius
                    };
                    path += ` L ${before.x} ${before.y} Q ${current.x} ${current.y} ${after.x} ${after.y}`;
                }
                const last = points[points.length - 1];
                return `${path} L ${last.x} ${last.y}`;
            },

            edgeIsFocused(edge) {
                if (this.hoveredEdgeKey === edge.key) return true;
                if (this.hoveredNodeId == null) return false;
                return Number(edge.from) === Number(this.hoveredNodeId) ||
                    Number(edge.to) === Number(this.hoveredNodeId);
            },

            edgeClasses(edge) {
                const hasHoverFocus = this.hoveredNodeId != null || this.hoveredEdgeKey != null;
                const focused = this.edgeIsFocused(edge);
                const relatedToDragging = this.dragging.id != null &&
                    (Number(edge.from) === Number(this.dragging.id) || Number(edge.to) === Number(this.dragging.id));
                return {
                    'is-focused': focused,
                    'is-muted': hasHoverFocus && !focused,
                    'is-dragging-related': relatedToDragging,
                    'is-dragging-muted': this.dragging.id != null && !relatedToDragging
                };
            },

            edgeMarker(edge) {
                const active = this.edgeIsFocused(edge) ||
                    (this.dragging.id != null &&
                        (Number(edge.from) === Number(this.dragging.id) || Number(edge.to) === Number(this.dragging.id)));
                return active ? 'url(#wfArrowActive)' : 'url(#wfArrow)';
            },

            nodeStyle(n) {
                const p = this.getNodePos(n.id);
                return {
                    left: p.x + 'px',
                    top: p.y + 'px',
                    width: this.nodeWidthPx + 'px',
                    minHeight: this.nodeMinHeight + 'px'
                };
            },

            zoomIn() { this.zoom = Math.min(2, Math.round((this.zoom + 0.1) * 10) / 10); },
            zoomOut() { this.zoom = Math.max(0.4, Math.round((this.zoom - 0.1) * 10) / 10); },
            resetZoom() { this.zoom = 1; },

            onNodeMouseDown(e, id) {
                if (!this.organizandoOrdem || e.button !== 0) return;
                e.preventDefault();
                const pos = this.manualPositions[id] || this.positionsById[id] || { x: 0, y: 0 };
                const rect = this.$refs.wfCanvas?.getBoundingClientRect();
                const scale = this.zoom || 1;
                const mouseX = e.clientX - (rect?.left || 0);
                const mouseY = e.clientY - (rect?.top || 0);
                const worldX = (mouseX - this.panX) / scale;
                const worldY = (mouseY - this.panY) / scale;

                this.dragging.id = id;
                this.dragging.offsetX = worldX - pos.x;
                this.dragging.offsetY = worldY - pos.y;
                this.dragging.startX = mouseX;
                this.dragging.startY = mouseY;
                this.dragging.moved = false;

                document.addEventListener('mousemove', this.onMouseMove);
                document.addEventListener('mouseup', this.onMouseUp);
            },

            onMouseMove(e) {
                if (!this.dragging.id) return;
                const rect = this.$refs.wfCanvas?.getBoundingClientRect();
                const scale = this.zoom || 1;
                const mouseX = e.clientX - (rect?.left || 0);
                const mouseY = e.clientY - (rect?.top || 0);
                const worldX = (mouseX - this.panX) / scale;
                const worldY = (mouseY - this.panY) / scale;

                if (!this.dragging.moved) {
                    const dx = mouseX - this.dragging.startX;
                    const dy = mouseY - this.dragging.startY;
                    if (Math.abs(dx) > 3 || Math.abs(dy) > 3) this.dragging.moved = true;
                }

                const x = Math.max(0, Math.round(worldX - this.dragging.offsetX));
                const y = Math.max(0, Math.round(worldY - this.dragging.offsetY));
                this.$set(this.manualPositions, this.dragging.id, { x, y });
            },

            onMouseUp() {
                const idArrastado = this.dragging.id;
                if (idArrastado && this.dragging.moved) {
                    this.suppressClickOnce = true;
                    setTimeout(() => { this.suppressClickOnce = false; }, 0);

                    const posicaoArrastada = this.manualPositions[idArrastado] || this.positionsById[idArrastado];
                    const centroArrastado = {
                        x: posicaoArrastada.x + this.nodeWidthPx / 2,
                        y: posicaoArrastada.y + (this.nodeHeightsMap[idArrastado] || this.nodeMinHeight) / 2
                    };
                    let indiceDestino = this.ordemRascunho.indexOf(idArrastado);
                    let menorDistancia = Number.MAX_SAFE_INTEGER;

                    this.ordemRascunho.forEach((id, index) => {
                        const slot = this.positionsById[id];
                        if (!slot) return;
                        const dx = centroArrastado.x - (slot.x + this.nodeWidthPx / 2);
                        const dy = centroArrastado.y - (slot.y + (this.nodeHeightsMap[id] || this.nodeMinHeight) / 2);
                        const distancia = dx * dx + dy * dy;
                        if (distancia < menorDistancia) {
                            menorDistancia = distancia;
                            indiceDestino = index;
                        }
                    });

                    const proximaOrdem = this.ordemRascunho.filter(id => id !== idArrastado);
                    proximaOrdem.splice(indiceDestino, 0, idArrastado);
                    const ordemNormalizada = this.empilharInativosNoFim(proximaOrdem);

                    if (this.ordemRespeitaDependencias(ordemNormalizada)) {
                        this.ordemRascunho = ordemNormalizada;
                        this.ordemAlterada = this.ordemRascunho.some(
                            (id, index) => id !== this.ordemOriginal[index]
                        );
                    } else {
                        avisoToast('Essa posição colocaria o artefato antes de uma dependência.', 'warning');
                    }
                    this.$delete(this.manualPositions, idArrastado);
                }
                this.dragging.id = null;
                this.dragging.offsetX = 0;
                this.dragging.offsetY = 0;
                this.dragging.moved = false;
                document.removeEventListener('mousemove', this.onMouseMove);
                document.removeEventListener('mouseup', this.onMouseUp);
            },

            onCanvasMouseDown(e) {
                if (e.target.closest('.wf-node')) return;
                if (this.dragging.id) return;
                if (e.button !== 0) return;

                e.preventDefault();
                this.panning.active = true;
                this.panning.startX = e.clientX;
                this.panning.startY = e.clientY;
                this.panning.startPanX = this.panX;
                this.panning.startPanY = this.panY;

                document.addEventListener('mousemove', this.onCanvasMouseMove);
                document.addEventListener('mouseup', this.onCanvasMouseUp);
            },
            onCanvasMouseMove(e) {
                if (!this.panning.active) return;
                const dx = e.clientX - this.panning.startX;
                const dy = e.clientY - this.panning.startY;
                this.panX = this.panning.startPanX + dx;
                this.panY = this.panning.startPanY + dy;
            },
            onCanvasMouseUp() {
                if (!this.panning.active) return;
                this.panning.active = false;
                document.removeEventListener('mousemove', this.onCanvasMouseMove);
                document.removeEventListener('mouseup', this.onCanvasMouseUp);
            },

            onNodeClick(id) {
                if (this.suppressClickOnce) return;
                this.openModeloById(id);
            },

            clamp(v, min, max) { return v < min ? min : (v > max ? max : v); },

            agendarMedicaoDosCards() {
                if (this._medicaoAgendada) return;
                this._medicaoAgendada = true;
                const agendar = typeof window !== 'undefined' && window.requestAnimationFrame
                    ? window.requestAnimationFrame.bind(window)
                    : (fn => setTimeout(fn, 16));
                agendar(() => {
                    this._medicaoAgendada = false;
                    this.medirAlturasDosCards();
                });
            },

            // As faixas das conexões só ficam fora dos cards se a altura usada no layout
            // for a altura realmente renderizada, por isso a medição vai para o estado.
            medirAlturasDosCards() {
                const raiz = this.$el;
                if (!raiz || typeof raiz.querySelectorAll !== 'function') return;

                const elementos = raiz.querySelectorAll('.wf-node');
                if (!elementos.length) {
                    if (Object.keys(this.medidasNodes).length) this.medidasNodes = {};
                    return;
                }

                const escala = this.zoom || 1;
                const medidas = {};
                elementos.forEach(elemento => {
                    const id = elemento.getAttribute('data-id');
                    if (!id) return;
                    const altura = Math.ceil(elemento.getBoundingClientRect().height / escala);
                    if (altura > 0) medidas[id] = altura;
                });

                const chaves = Object.keys(medidas);
                const mudou = chaves.length !== Object.keys(this.medidasNodes).length ||
                    chaves.some(id => this.medidasNodes[id] !== medidas[id]);
                if (mudou) this.medidasNodes = medidas;
            },

            getNodeBox(id) {
                const p = this.getNodePos(id);
                const w = this.nodeWidthPx;
                const h = this.nodeHeightsMap[id] || this.nodeMinHeight;
                return { x: p.x, y: p.y, w, h, cx: p.x + w / 2, cy: p.y + h / 2 };
            },

            _pickSides(a, b) {
                const dx = b.cx - a.cx;
                const dy = b.cy - a.cy;
                if (Math.abs(dx) >= Math.abs(dy)) {
                    return {
                        from: dx >= 0 ? 'right' : 'left',
                        to: dx >= 0 ? 'left' : 'right',
                        axis: 'x'
                    };
                } else {
                    return {
                        from: dy >= 0 ? 'bottom' : 'top',
                        to: dy >= 0 ? 'top' : 'bottom',
                        axis: 'y'
                    };
                }
            },

            isArtefatoAtivo(cfg) {
                return cfg?.flAtivo !== false;
            },

            // Modelo nativo vem com idCliente nulo; qualquer valor preenchido indica
            // inclusão pelo workflow, inclusive o cliente 0 (admin).
            isArtefatoAdicionadoPeloCliente(modeloId) {
                return this.modelosById?.[modeloId]?.idCliente != null;
            },

            getTooltipPrazo(cfg) {
                if (!cfg?.flPrazo) return null;
                const dias = cfg.nrDiasPrazo || '-';
                const tipo = cfg.tpDiasPrazo === 'UTS' ? 'úteis' : 'corridos';
                const inicio = cfg.tpInicioPrazo === 'FINALIZACAO'
                    ? 'após a finalização dos artefatos dependentes'
                    : 'na abertura do processo';
                return {
                    text: `${dias} dia(s) (${tipo})`,
                    subtitle: `Contado ${inicio}`,
                    type: 'prazo'
                };
            },

            getTooltipRevisao(cfg) {
                if (!cfg?.flRevisao) return null;
                return {
                    text: 'Etapa de revisão habilitada',
                    subtitle: 'Destinatários definidos no envio do artefato',
                    type: 'success'
                };
            },

            getTooltipAprovacao(cfg) {
                if (!cfg?.flAprovacao) return null;
                return {
                    text: 'Etapa de aprovação habilitada',
                    subtitle: 'Destinatários definidos no envio do artefato',
                    type: 'info'
                };
            },

            getTooltipAssinatura(cfg) {
                if (!cfg?.flAssinatura) return null;
                return {
                    type: 'warning'
                };
            },

            getTooltipDependencias(modeloId) {
                const deps = this.depModeloNomesByModeloId(modeloId);
                if (!deps.length) return null;
                return {
                    text: 'Depende de:',
                    list: deps,
                    type: 'deps'
                };
            },


        },

        mounted() {
            this.load();

            this._onResize = () => {
                this.viewport = { w: window.innerWidth || 0, h: window.innerHeight || 0 };
                this.$nextTick(() => {
                    this.medirAlturasDosCards();
                    this.$forceUpdate();
                });
            };
            window.addEventListener('resize', this._onResize);

            this._onResize();
        },
        updated() {
            this.agendarMedicaoDosCards();
        },
        beforeUnmount() {
            window.removeEventListener('resize', this._onResize);
        },
    }
</script>

<style scoped lang="scss">
    .workflow-readonly-banner {
        border: 1px solid rgba(220,53,69,.25);
        background: rgba(220,53,69,.08);
        color: inherit;
        padding: .75rem 1rem;
        border-radius: .75rem;
        margin-top: .75rem;
    }

    .btn-md {
        z-index: 1001;
    }

    .workflow-board {
        background: #fff;
        border: 1px solid rgba(0,0,0,.08);
        border-radius: 14px;
        box-shadow: 0 2px 10px rgba(0,0,0,.05);
        overflow: hidden;
    }

    .workflow-board__header {
        padding: 14px 18px;
        border-bottom: 1px solid rgba(0,0,0,.06);
        background: linear-gradient(0deg, rgba(0,0,0,.02), rgba(0,0,0,.02)), #fff;
    }

    .workflow-board__body {
        padding: 16px;
    }

    .models-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 14px;
    }

    .models-empty {
        padding: 12px 4px;
        color: #666;
        font-size: .95rem;
    }

    /* Workflow canvas */
    .wf-wrapper {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .wf-toolbar {
        padding: 6px 4px;
        border: 1px dashed rgba(0,0,0,.06);
        border-radius: 8px;
        background: linear-gradient(0deg, rgba(0,0,0,.01), rgba(0,0,0,.01)), #fff;
    }

    .wf-toolbar-name {
        display: flex;
        align-items: center;
        gap: 8px;
        min-width: 0;

        .form-control {
            width: min(280px, 42vw);
            min-width: 160px;
        }

        .btn {
            white-space: nowrap;
        }
    }

    @media (max-width: 767.98px) {
        .wf-toolbar-name {
            width: 100%;

            .form-control {
                width: 100%;
                min-width: 0;
            }
        }
    }

    .wf-canvas {
        position: relative;
        overflow: hidden;
        border: 1px solid rgba(0,0,0,.06);
        border-radius: 10px;
        background: linear-gradient(90deg, rgba(0,0,0,.03) 1px, transparent 1px) 0 0 / 24px 24px, linear-gradient(0deg, rgba(0,0,0,.03) 1px, transparent 1px) 0 0 / 24px 24px, #fff;
        min-height: 420px;
        user-select: none;
        cursor: grab;
    }

    .wf-canvas.is-panning {
        cursor: grabbing;
    }

    .wf-inner {
        position: absolute;
        left: 0;
        top: 0;
    }

    .wf-edges {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 0;
        pointer-events: none;
    }

    .wf-edge-group {
        opacity: 1;
        transition: opacity .18s ease;
    }

    .wf-edge-halo,
    .wf-edge-line,
    .wf-edge-hit {
        fill: none;
        stroke-linecap: round;
        stroke-linejoin: round;
    }

    .wf-edge-halo {
        stroke: rgba(255, 255, 255, .96);
        stroke-width: 7;
        pointer-events: none;
    }

    .wf-edge-line {
        stroke: #94a3b8;
        stroke-width: 2.25;
        pointer-events: none;
        transition: stroke .18s ease, stroke-width .18s ease, opacity .18s ease;
    }

    .wf-edge-hit {
        stroke: transparent;
        stroke-width: 16;
        pointer-events: stroke;
        cursor: help;
    }

    #wfArrow path {
        fill: #94a3b8;
    }

    #wfArrowActive path {
        fill: #2563eb;
    }

    .wf-edge-group.is-focused {
        .wf-edge-line {
            stroke: #2563eb;
            stroke-width: 3.25;
        }
    }

    .wf-edge-group.is-muted,
    .wf-edge-group.is-dragging-muted {
        opacity: .14;
    }

    .wf-edge-group.is-dragging-related {
        opacity: 1;

        .wf-edge-line {
            stroke: #0ea5e9;
            stroke-width: 3;
            stroke-dasharray: 8 6;
            animation: wf-edge-dash .7s linear infinite;
        }
    }

    @keyframes wf-edge-dash {
        to {
            stroke-dashoffset: -14;
        }
    }

    .wf-node {
        position: absolute;
        background: #fff;
        border: 1px solid rgba(0,0,0,.08);
        border-radius: 12px;
        box-shadow: 0 2px 8px rgba(0,0,0,.06);
        transition: box-shadow .12s ease, transform .12s ease, border-color .12s ease;
        padding: 12px 14px;
        cursor: pointer;
        overflow: visible;
        z-index: 1;
    }

    .wf-node:hover {
        transform: translateY(-1px);
        border-color: rgba(0,0,0,.12);
        box-shadow: 0 8px 18px rgba(0,0,0,.10);
    }

    .wf-order-hint {
        padding-left: 8px;
        border-left: 1px solid rgba(100, 116, 139, .3);
    }

    .wf-node--ordering {
        cursor: grab;
        border-style: dashed;
    }

    .wf-node--dragging {
        cursor: grabbing;
        z-index: 5;
        transform: translateY(-2px);
        border-color: rgba(37, 99, 235, .55);
        box-shadow: 0 12px 28px rgba(37, 99, 235, .2);
    }

    .wf-node-dragging {
        box-shadow: 0 0 10px rgba(0,0,0,0.2);
        border-color: rgba(0,0,0,0.2);
        transform: translateY(-2px);
    }

    .wf-node-title {
        font-weight: 700;
        font-size: 1rem;
        color: #222;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 6px;
    }

    .wf-node-meta {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        margin-bottom: 6px;
    }

    .wf-node-deps {
        margin-top: 2px;
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        padding-right: 32px;
    }

    .wf-node-open {
        margin-top: 4px;
    }

    .wf-node-body {
        display: flex;
        flex-direction: column;
        gap: 6px;
        padding-left: 28px;
    }

    .wf-node-order {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 24px;
        height: 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 999px;
        background: #EEF2FF;
        border: 1px solid #C7D2FE;
        color: #3730A3;
        font-size: .75rem;
        font-weight: 800;
        line-height: 1;
    }

    .wf-node--inativo {
        border-color: rgba(220, 53, 69, .35);
    }

    .wf-node > .wf-node-status {
        position: absolute;
        right: 10px;
        bottom: 10px;
        width: 24px;
        height: 24px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 999px;
        border: 1px solid transparent;
        box-shadow: 0 1px 4px rgba(0,0,0,.12);
    }

    .wf-node-status--ativo {
        background: #E7F5EE;
        border-color: #C9E9D8;
        color: #115E36;
    }

    .wf-node-status--inativo {
        background: #FDECEE;
        border-color: #F5C2C7;
        color: #B02A37;
    }

    .chip {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 6px 10px;
        font-weight: 600;
        font-size: .9rem;
        border-radius: 999px;
        border: 1px solid rgba(0,0,0,.06);
        background: #f8fafc;
        color: #111827;
    }

    .chip-on {
        background: #E7F5EE;
        border-color: #C9E9D8;
        color: #115E36;
    }

    .chip-off {
        background: #F8F9FB;
        border-color: #E5E7EB;
        color: #6B7280;
    }

    .muted {
        color: #6b7280;
        font-weight: 500;
    }

    @media (max-width: 576px) {
        .wf-canvas {
            min-height: 60vh;
        }
    }

    /* Custom Tooltips */
    .custom-tooltip {
        position: relative;
        cursor: pointer;
    }

    .custom-tooltip .tooltip-content {
        visibility: hidden;
        opacity: 0;
        position: absolute;
        bottom: 125%;
        left: 50%;
        transform: translateX(-50%);
        background: var(--bs-primary);
        color: white;
        text-align: center;
        border-radius: 12px;
        padding: 12px 16px;
        z-index: 10000;
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
        font-size: 0.85rem;
        font-weight: 500;
        line-height: 1.4;
        min-width: 220px;
        max-width: 420px;
        white-space: pre-line;
        backdrop-filter: blur(10px);
        border: 1px solid rgba(255, 255, 255, 0.2);
        transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        transform: translateX(-50%) translateY(10px) scale(0.8);
        pointer-events: none;
    }

    .custom-tooltip .tooltip-content::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -6px;
        border-width: 6px;
        border-style: solid;
        border-color: var(--bs-primary) transparent transparent transparent;
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
    }

    .custom-tooltip:hover .tooltip-content {
        visibility: visible;
        opacity: 1;
        transform: translateX(-50%) translateY(0) scale(1);
    }

    /* Tooltip variants */
    .tooltip-success .tooltip-content {
        background: var(--bs-success);
    }

    .tooltip-success .tooltip-content::after {
        border-color: var(--bs-success) transparent transparent transparent;
    }

    .tooltip-info .tooltip-content {
        background: var(--bs-info);
    }

    .tooltip-info .tooltip-content::after {
        border-color: var(--bs-info) transparent transparent transparent;
    }

    .tooltip-warning .tooltip-content {
        background: var(--bs-warning);
        color: var(--bs-dark);
    }

    .tooltip-warning .tooltip-content::after {
        border-color: var(--bs-warning) transparent transparent transparent;
    }

    .tooltip-danger .tooltip-content {
        background: var(--bs-danger);
    }

    .tooltip-danger .tooltip-content::after {
        border-color: var(--bs-danger) transparent transparent transparent;
    }

    .tooltip-deps .tooltip-content {
        background: var(--bs-primary);
        text-align: left;
        padding: 16px 20px;
        max-width: 320px;
    }

    .tooltip-deps .tooltip-content::after {
        border-color: var(--bs-primary) transparent transparent transparent;
    }

    .tooltip-deps .tooltip-title {
        font-weight: 600;
        margin-bottom: 8px;
        font-size: 0.9rem;
    }

    .tooltip-deps .tooltip-list {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .tooltip-deps .tooltip-list li {
        padding: 2px 0;
        position: relative;
        padding-left: 16px;
    }

    .tooltip-deps .tooltip-list li::before {
        content: "•";
        position: absolute;
        left: 0;
        color: rgba(255, 255, 255, 0.8);
        font-weight: bold;
    }

    /* ============================================
       DARK THEME - Modern & Beautiful
       ============================================ */

    /* Workflow Board */
    [data-bs-theme="dark"] .workflow-board {
        background: #1a1d29;
        border-color: rgba(255, 255, 255, 0.1);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
    }

    [data-bs-theme="dark"] .workflow-board__header {
        background: linear-gradient(0deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03)), #1a1d29;
        border-bottom-color: rgba(255, 255, 255, 0.1);
    }

    [data-bs-theme="dark"] .workflow-board__header h5 {
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .workflow-board__body {
        background: #1a1d29;
    }

    /* Empty State */
    [data-bs-theme="dark"] .models-empty {
        color: #9ca3af;
    }

    /* Toolbar */
    [data-bs-theme="dark"] .wf-toolbar {
        background: linear-gradient(0deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)), #1a1d29;
        border-color: rgba(255, 255, 255, 0.08);
    }

    [data-bs-theme="dark"] .wf-toolbar .text-muted {
        color: #9ca3af !important;
    }

    /* Canvas */
    [data-bs-theme="dark"] .wf-canvas {
        background: linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px) 0 0 / 24px 24px, linear-gradient(0deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px) 0 0 / 24px 24px, #0f1117;
        border-color: rgba(255, 255, 255, 0.1);
    }

    /* Workflow Nodes */
    [data-bs-theme="dark"] .wf-node {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(255, 255, 255, 0.12);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    }

    [data-bs-theme="dark"] .wf-node:hover {
        background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
        border-color: rgba(255, 255, 255, 0.2);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
    }

    [data-bs-theme="dark"] .wf-node-title {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .wf-node-order {
        background: rgba(79, 70, 229, .24);
        border-color: rgba(129, 140, 248, .4);
        color: #c7d2fe;
    }

    [data-bs-theme="dark"] .wf-order-hint {
        border-left-color: rgba(148, 163, 184, .35);
    }

    [data-bs-theme="dark"] .wf-node--inativo {
        border-color: rgba(248, 113, 113, .4);
    }

    [data-bs-theme="dark"] .wf-node-status--ativo {
        background: linear-gradient(135deg, #0d3d2a 0%, #0f5235 100%);
        border-color: rgba(34, 197, 94, .35);
        color: #86efac;
    }

    [data-bs-theme="dark"] .wf-node-status--inativo {
        background: linear-gradient(135deg, #3f1418 0%, #551a20 100%);
        border-color: rgba(248, 113, 113, .35);
        color: #fca5a5;
    }

    /* Chips */
    [data-bs-theme="dark"] .meta-label {
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .chip {
        background: linear-gradient(135deg, #1a1f2e 0%, #232938 100%);
        border-color: rgba(255, 255, 255, 0.12);
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .chip-on {
        background: linear-gradient(135deg, #0d3d2a 0%, #0f5235 100%);
        border-color: rgba(34, 197, 94, 0.3);
        color: #86efac;
    }

    [data-bs-theme="dark"] .chip-off {
        background: linear-gradient(135deg, #1a1f2e 0%, #252a3a 100%);
        border-color: rgba(255, 255, 255, 0.08);
        color: #6b7280;
    }

    [data-bs-theme="dark"] .muted {
        color: #9ca3af;
    }

    /* SVG Edges */
    [data-bs-theme="dark"] .wf-edge-halo {
        stroke: rgba(15, 17, 23, .96);
    }

    [data-bs-theme="dark"] .wf-edge-line {
        stroke: #64748b;
    }

    [data-bs-theme="dark"] #wfArrow path {
        fill: #64748b;
    }

    [data-bs-theme="dark"] #wfArrowActive path {
        fill: #60a5fa;
    }

    [data-bs-theme="dark"] .wf-edge-group.is-focused .wf-edge-line {
        stroke: #60a5fa;
    }

    [data-bs-theme="dark"] .wf-edge-group.is-dragging-related .wf-edge-line {
        stroke: #38bdf8;
    }

    /* Tooltips Dark Theme */
    [data-bs-theme="dark"] .custom-tooltip .tooltip-content {
        background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
        border-color: rgba(255, 255, 255, 0.15);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);
    }

    [data-bs-theme="dark"] .tooltip-success .tooltip-content {
        background: linear-gradient(135deg, #065f46 0%, #059669 100%);
    }

    [data-bs-theme="dark"] .tooltip-info .tooltip-content {
        background: linear-gradient(135deg, #0c4a6e 0%, #0284c7 100%);
    }

    [data-bs-theme="dark"] .tooltip-warning .tooltip-content {
        background: linear-gradient(135deg, #92400e 0%, #d97706 100%);
        color: #fef3c7;
    }

    [data-bs-theme="dark"] .tooltip-deps .tooltip-content {
        background: linear-gradient(135deg, #4c1d95 0%, #7c3aed 100%);
    }

    /* Loading Text */
    [data-bs-theme="dark"] .py-4.text-muted {
        color: #9ca3af !important;
    }

    /* Buttons */
    [data-bs-theme="dark"] .btn-outline-secondary {
        color: #d1d5db;
        border-color: rgba(255, 255, 255, 0.12);
        background: linear-gradient(135deg, #1a1f2e 0%, #232938 100%);
    }

    [data-bs-theme="dark"] .btn-outline-secondary:hover {
        color: #f3f4f6;
        background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
        border-color: rgba(255, 255, 255, 0.2);
    }

    /* Modal Dark Theme */
    [data-bs-theme="dark"] .modal-content {
        background: linear-gradient(135deg, #1a1d29 0%, #1e2330 100%);
        border-color: rgba(255, 255, 255, 0.1);
    }

    [data-bs-theme="dark"] .modal-header {
        background: linear-gradient(0deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.03)), #1a1d29;
        border-bottom-color: rgba(255, 255, 255, 0.1);
    }

    [data-bs-theme="dark"] .modal-header .modal-title {
        color: #f3f4f6;
    }

    [data-bs-theme="dark"] .modal-body {
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .modal-footer {
        border-top-color: rgba(255, 255, 255, 0.1);
    }

    /* Form Elements Dark */
    [data-bs-theme="dark"] .form-control,
    [data-bs-theme="dark"] .form-select {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.12);
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .form-control:focus,
    [data-bs-theme="dark"] .form-select:focus {
        background: #1a1d29;
        border-color: rgba(59, 130, 246, 0.5);
        color: #f3f4f6;
        box-shadow: 0 0 0 0.25rem rgba(59, 130, 246, 0.15);
    }

    [data-bs-theme="dark"] .form-label {
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .form-check-label {
        color: #d1d5db;
    }

    /* Borders and Dividers */
    [data-bs-theme="dark"] .border {
        border-color: rgba(255, 255, 255, 0.1) !important;
    }

    [data-bs-theme="dark"] .rounded.bg-light {
        background: linear-gradient(135deg, #0f1117 0%, #1a1d29 100%) !important;
        border-color: rgba(255, 255, 255, 0.1);
    }

    /* Progress Bar Dark */
    [data-bs-theme="dark"] .progress {
        background: #0f1117;
    }

    [data-bs-theme="dark"] .progress-bar {
        background: linear-gradient(90deg, #3b82f6 0%, #2563eb 100%);
    }

    [data-bs-theme="dark"] .text-danger {
        color: #fca5a5 !important;
    }

    [data-bs-theme="dark"] .text-muted.small {
        color: #9ca3af !important;
    }

    /* Button Group Dark */
    [data-bs-theme="dark"] .btn-group .btn {
        border-color: rgba(255, 255, 255, 0.12);
    }

    [data-bs-theme="dark"] .btn-sm.btn-outline-secondary {
        color: #d1d5db;
        background: #1a1f2e;
        border-color: rgba(255, 255, 255, 0.12);
    }

    [data-bs-theme="dark"] .btn-sm.btn-outline-secondary:hover {
        color: #f3f4f6;
        background: #252b3d;
        border-color: rgba(255, 255, 255, 0.2);
    }

    :deep(#ModalWorkflowGeral.modern-modal) {
        .modal-modern-content {
            border-radius: 20px;
            background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
            box-shadow: 0 22px 60px rgba(15, 23, 42, 0.18);
            position: relative;
        }

        .modal-modern-header {
            display: flex;
            align-items: flex-start;
            gap: 18px;
            padding: 32px 32px 20px;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                bottom: -1px;
                left: 32px;
                right: 32px;
                height: 1px;
                background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
            }

            .header-icon {
                width: 60px;
                height: 60px;
                border-radius: 18px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(56, 189, 248, 0.2) 100%);
                color: #2563eb;
                flex-shrink: 0;
            }

            .header-text {
                flex: 1;

                h2 {
                    margin: 0;
                    font-size: 24px;
                    font-weight: 700;
                    color: #0f172a;
                }

                p {
                    margin: 8px 0 0;
                    color: #475569;
                    font-size: 14px;
                    line-height: 1.6;
                    max-width: 520px;
                }
            }

            .header-status {
                display: flex;
                align-items: center;
                gap: 12px;

                .badge-artefato {
                    background: linear-gradient(135deg, rgba(56, 189, 248, 0.18) 0%, rgba(59, 130, 246, 0.18) 100%);
                    color: #1d4ed8;
                    font-weight: 600;
                    padding: 6px 14px;
                    border-radius: 999px;
                    border: 1px solid rgba(59, 130, 246, 0.24);
                    text-transform: uppercase;
                    letter-spacing: 0.4px;
                    font-size: 11px;
                }
            }
        }

        .modal-modern-body {
            padding: 28px 32px 24px;
            display: flex;
            flex-direction: column;
            gap: 24px;
        }

        .modal-modern-footer {
            padding: 0 32px 32px;
        }

        .section-stack {
            display: flex;
            flex-direction: column;
            gap: 22px;
        }

        .section-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
            gap: 20px;
        }

        .section-card {
            background: linear-gradient(135deg, rgba(255, 255, 255, 0.92) 0%, rgba(248, 250, 252, 0.96) 100%);
            border: 1px solid rgba(226, 232, 240, 0.8);
            border-radius: 18px;
            padding: 20px 22px;
            box-shadow: 0 12px 28px rgba(148, 163, 184, 0.14);
            display: flex;
            flex-direction: column;
            gap: 18px;
            transition: transform .2s ease, box-shadow .2s ease;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 18px 38px rgba(148, 163, 184, 0.22);
            }

            &--compact {
                gap: 14px;
                padding: 18px 20px;
            }
        }

        .section-header {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            flex-wrap: wrap;
            gap: 16px;

            &__info {
                display: flex;
                gap: 14px;
                align-items: flex-start;

                h3 {
                    margin: 0;
                    font-size: 18px;
                    font-weight: 700;
                    color: #1f2937;
                }

                p {
                    margin: 6px 0 0;
                    color: #64748b;
                    font-size: 13px;
                    max-width: 460px;
                    line-height: 1.5;
                }
            }

            &__actions {
                display: flex;
                align-items: center;
                gap: 16px;
                flex-wrap: wrap;
                justify-content: flex-end;
            }
        }

        .section-icon {
            width: 44px;
            height: 44px;
            border-radius: 14px;
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.16) 0%, rgba(14, 165, 233, 0.16) 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            color: #2563eb;
            flex-shrink: 0;
        }

        .section-content {
            display: flex;
            flex-direction: column;
            gap: 18px;
            min-height: 0;
        }

        .runtime-envolvidos-note {
            font-size: 0.88rem;
            color: #64748b;
            line-height: 1.5;
            padding: 12px 14px;
            border-radius: 10px;
            background: rgba(35, 95, 232, 0.06);
            border-left: 3px solid #235FE8;
        }

        .dependency-toolbar {
            background: rgba(248, 250, 252, 0.9);
            border: 1px solid rgba(226, 232, 240, 0.8);
            border-radius: 16px;
            padding: 16px 18px;
            display: flex;
            flex-wrap: wrap;
            gap: 16px;
            align-items: center;
            justify-content: center;

            .toolbar-text {
                color: #475569;
                font-size: 13px;
                max-width: 460px;
                line-height: 1.5;
                flex: 0 0 auto;
            }

            .toolbar-actions {
                display: flex;
                align-items: center;
                gap: 14px;
                flex-wrap: wrap;
                justify-content: center;
                flex: 0 0 auto;
            }
        }

        .modern-input {
            .input-group-text {
                background: rgba(248, 250, 252, 0.9);
                border: 1px solid rgba(203, 213, 225, 0.7);
                border-right: none;
                border-radius: 12px 0 0 12px;
                color: #64748b;
            }

            .form-control {
                border-radius: 0 12px 12px 0;
            }
        }

        .dependency-list {
            display: flex;
            flex-direction: column;
            gap: 12px;
            max-height: 52vh;
            overflow-y: auto;
            padding-right: 4px;
        }

        .dependency-list.user-list {
            max-height: 280px !important;
            min-height: 120px;
            overflow-y: auto !important;
            overflow-x: hidden;
            flex-shrink: 0;
            flex-grow: 0;
            box-sizing: border-box;
        }

        .section-card .section-content .dependency-list.user-list {
            max-height: 280px !important;
            overflow-y: auto !important;
        }

        .user-list-scroll {
            display: flex;
            flex-direction: column;
            gap: 12px;
            max-height: 200px !important;
            min-height: 0;
            overflow-y: auto !important;
            overflow-x: hidden;
            flex-shrink: 0;
            flex-grow: 0;
            box-sizing: border-box;
            padding-right: 4px;
            position: relative;
        }

        .dependency-item {
            border: 1px solid rgba(226, 232, 240, 0.8);
            border-radius: 14px;
            padding: 16px 18px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 16px;
            background: rgba(255, 255, 255, 0.88);
            transition: all 0.2s ease;

            &:hover {
                border-color: rgba(59, 130, 246, 0.35);
                box-shadow: 0 12px 24px rgba(37, 99, 235, 0.12);
            }

            &__info {
                display: flex;
                align-items: center;
                gap: 20px;
                flex: 1;
            }
        }

        .dependency-title {
            display: inline-block;
            font-weight: 600;
            color: #0f172a;
            margin: 0;
        }

        .dependency-description {
            color: #64748b;
            font-size: 13px;
        }

        .dep-check {
            width: 1.1rem;
            height: 1.1rem;
            margin-top: 2px;
        }

        .badge-counter {
            background: rgba(59, 130, 246, 0.12);
            border: 1px solid rgba(59, 130, 246, 0.3);
            color: #2563eb;
            font-weight: 600;
            padding: 6px 12px;
            border-radius: 999px;
        }

        .badge-selected {
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.14) 0%, rgba(37, 99, 235, 0.14) 100%);
            color: #1d4ed8;
            border: 1px solid rgba(59, 130, 246, 0.3);
            border-radius: 999px;
            font-size: 12px;
            font-weight: 600;
            padding: 5px 12px;
        }

        .dependency-list::-webkit-scrollbar {
            width: 8px;
        }

        .dependency-list::-webkit-scrollbar-track {
            background: #f1f5f9;
            border-radius: 8px;
        }

        .dependency-list::-webkit-scrollbar-thumb {
            background: linear-gradient(135deg, #1f7bff 0%, #00b894 100%);
            border-radius: 8px;
        }

        .user-list-scroll {
            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-track {
                background: rgba(241, 245, 249, 0.6);
                border-radius: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
                border-radius: 6px;

                &:hover {
                    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                }
            }
        }

        .dependency-list.user-list {
            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-track {
                background: rgba(241, 245, 249, 0.6);
                border-radius: 6px;
            }

            &::-webkit-scrollbar-thumb {
                background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
                border-radius: 6px;

                &:hover {
                    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                }
            }
        }

        .form-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
            gap: 18px;
        }

        .form-group {
            display: flex;
            flex-direction: column;
            gap: 8px;
        }

        .form-label {
            font-weight: 600;
            color: #0f172a;
            font-size: 13px;
            letter-spacing: 0.3px;
            text-transform: uppercase;
        }

        .form-select {
            appearance: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-position: right 16px center;
            background-size: 14px 9px;
            padding-right: 46px;
            cursor: pointer;
        }

        .form-control {
            border-radius: 12px;
            border: 2px solid rgba(148, 163, 184, 0.22);
            background: #ffffff;
            padding: 12px 14px;
            font-size: 14px;
            color: #1f2937;
            transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

            &:focus {
                border-color: rgba(37, 99, 235, 0.45);
                box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
                background: #ffffff;
                color: #0f172a;
            }
        }

        .form-check-label {
            color: #1f2937;
            font-weight: 600;
        }

        .form-check-input {
            &:focus {
                border-color: rgba(37, 99, 235, 0.4);
                box-shadow: 0 0 0 0.25rem rgba(37, 99, 235, 0.18);
            }

            &:checked {
                background-color: #2563eb;
                border-color: #2563eb;
            }
        }

        .section-note {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 14px 18px;
            border-radius: 14px;
            background: rgba(248, 250, 252, 0.92);
            border: 1px solid rgba(226, 232, 240, 0.75);
            color: #475569;
            font-size: 13px;
            line-height: 1.5;

            strong {
                color: #1d4ed8;
            }

            &--muted {
                padding: 12px 18px;
                border-style: dashed;
                border-color: rgba(148, 163, 184, 0.35);
                background: rgba(248, 250, 252, 0.88);
            }
        }

        .btn-modern-primary {
            border: none;
            border-radius: 12px;
            padding: 16px 22px;
            font-weight: 700;
            letter-spacing: 0.4px;
            text-transform: uppercase;
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            box-shadow: 0 14px 32px rgba(37, 99, 235, 0.35);
            color: #ffffff !important;
            transition: transform 0.2s ease, box-shadow 0.2s ease;

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 18px 40px rgba(37, 99, 235, 0.45);
                color: #ffffff !important;
            }

            &:active {
                transform: translateY(0);
            }
        }

        .spinner-border {
            color: #2563eb;
        }
    }

    [data-bs-theme="dark"] #ModalWorkflowGeral.modern-modal {
        .modal-modern-content {
            background: linear-gradient(135deg, #0f172a 0%, #111827 100%) !important;
            border: 1px solid rgba(71, 85, 105, 0.45);
            box-shadow: 0 26px 68px rgba(0, 0, 0, 0.6);
        }

        .modal-modern-header::after {
            background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.2), transparent);
        }

        .modal-modern-body {
            background: transparent;
            color: #e2e8f0;
        }

        .modal-modern-footer {
            background: transparent;
        }

        .btn-pill.btn-white {
            background: rgba(15, 23, 42, 0.92) !important;
            border: 2px solid rgba(148, 163, 184, 0.25) !important;
            color: #e2e8f0;
        }

            .btn-pill.btn-white:hover {
                background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
                border-color: transparent !important;
                color: #ffffff;
            }

        .modal-modern-header {
            .header-icon {
                background: linear-gradient(135deg, rgba(59, 130, 246, 0.3) 0%, rgba(14, 165, 233, 0.3) 100%);
                color: #93c5fd;
            }

            .header-text {
                h2 {
                    color: #f8fafc;
                }

                p {
                    color: #cbd5f5;
                }
            }

            .header-status .badge-artefato {
                background: linear-gradient(135deg, rgba(99, 102, 241, 0.22) 0%, rgba(14, 165, 233, 0.22) 100%);
                border-color: rgba(99, 102, 241, 0.4);
                color: #c7d2fe;
            }
        }

        .section-card {
            background: linear-gradient(135deg, rgba(15, 23, 42, 0.92) 0%, rgba(30, 41, 59, 0.95) 100%);
            border: 1px solid rgba(71, 85, 105, 0.55);
            box-shadow: 0 18px 42px rgba(0, 0, 0, 0.55);
        }

        .section-header__info h3 {
            color: #f8fafc;
        }

        .section-header__info p {
            color: #94a3b8;
        }

        .section-icon {
            background: linear-gradient(135deg, rgba(37, 99, 235, 0.32) 0%, rgba(5, 150, 105, 0.26) 100%);
            color: #93c5fd;
        }

        .form-label {
            color: #e2e8f0;
        }

        .form-control,
        .form-select {
            background-color: rgba(15, 23, 42, 0.85);
            border-color: rgba(71, 85, 105, 0.6);
            color: #e2e8f0;

            &:focus {
                background-color: rgba(15, 23, 42, 0.95);
                color: #f8fafc;
            }
        }

        .form-select,
        .form-select:focus {
            background-color: rgba(15, 23, 42, 0.85);
            background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2394A3B8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-position: right 16px center;
            background-size: 14px 9px;
        }

            .form-select:focus {
                background-color: rgba(15, 23, 42, 0.95);
            }

        .form-select option {
            background: #1f2937;
            color: #e2e8f0;
        }

        .form-check-label {
            color: #e2e8f0;
        }

        .form-check-input {
            background-color: rgba(15, 23, 42, 0.9);
            border-color: rgba(71, 85, 105, 0.6);

            &:checked {
                background-color: #3b82f6;
                border-color: #3b82f6;
            }
        }

        .section-note {
            background: rgba(15, 23, 42, 0.82);
            border-color: rgba(71, 85, 105, 0.55);
            color: #cbd5f5;

            strong {
                color: #bfdbfe;
            }

            &--muted {
                background: rgba(15, 23, 42, 0.75);
                border-color: rgba(71, 85, 105, 0.45);
            }
        }

        .btn-modern-primary {
            background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
            box-shadow: 0 16px 36px rgba(37, 99, 235, 0.45);
        }

        .spinner-border {
            color: #3b82f6;
        }

        .dependency-toolbar {
            background: rgba(15, 23, 42, 0.86);
            border-color: rgba(71, 85, 105, 0.6);

            .toolbar-text {
                color: #cbd5f5;
            }
        }

        .user-list-scroll {
            &::-webkit-scrollbar-track {
                background: rgba(15, 23, 42, 0.6);
            }

            &::-webkit-scrollbar-thumb {
                background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);

                &:hover {
                    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                }
            }
        }

        .modern-input {
            .input-group-text {
                background-color: rgba(15, 23, 42, 0.82);
                border-color: rgba(71, 85, 105, 0.6);
                color: #94a3b8;
            }

            .form-control {
                background-color: rgba(15, 23, 42, 0.82);
                border-color: rgba(71, 85, 105, 0.6);
                color: #e2e8f0;
            }
        }

        .dependency-item {
            background: rgba(15, 23, 42, 0.9);
            border-color: rgba(71, 85, 105, 0.6);

            &:hover {
                border-color: rgba(59, 130, 246, 0.6);
                box-shadow: 0 16px 32px rgba(37, 99, 235, 0.35);
            }
        }

        .dependency-title {
            color: #e2e8f0;
        }

        .dependency-description {
            color: #94a3b8;
        }

        .badge-counter {
            background: rgba(59, 130, 246, 0.18);
            border-color: rgba(59, 130, 246, 0.35);
            color: #bfdbfe;
        }

        .badge-selected {
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.24) 0%, rgba(37, 99, 235, 0.24) 100%);
            color: #bfdbfe;
            border-color: rgba(59, 130, 246, 0.4);
        }

        .dependency-list::-webkit-scrollbar-thumb {
            background: linear-gradient(135deg, #2563eb 0%, #059669 100%);
        }

        .dependency-list.user-list {
            &::-webkit-scrollbar-track {
                background: rgba(15, 23, 42, 0.6);
            }

            &::-webkit-scrollbar-thumb {
                background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);

                &:hover {
                    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                }
            }
        }
    }

    @media (max-width: 768px) {
        :deep(#ModalWorkflowGeral.modern-modal) {
            .modal-modern-header, .modal-modern-body, .modal-modern-footer {
                padding: 24px 20px;
            }

            .modal-modern-header {
                flex-direction: column;
                align-items: stretch;

                &::after {
                    left: 20px;
                    right: 20px;
                }

                .header-icon {
                    width: 56px;
                    height: 56px;
                }
            }

            .section-card {
                padding: 18px;
            }

            .section-grid {
                grid-template-columns: 1fr;
            }
        }
    }

    @media (max-width: 576px) {
        :deep(#ModalWorkflowGeral.modern-modal) {
            .modal-dialog {
                margin: 12px;
            }

            .modal-modern-header .header-text h2 {
                font-size: 22px;
            }

            .section-header__info {
                flex-direction: column;
            }
        }
    }
</style>

